// functions and objects related to the LOHM calculators
// -- in product finder and the two modals

// TOGGLE LOHM CALCULATOR LOG
var show_lohm_calculator_log = false;
var debug__lohm_calculator = function() {	
	if( show_lohm_calculator_log ) {
		var arg_array = [];
		if( arguments.length == 1 ) {
			console.log(arguments[0]);
		} else {
			for (var i = 0; i < arguments.length; i++) {
				arg_array.push(arguments[i]);
			}
			console.log(arg_array);
		}
	}
}

debug__lohm_calculator('Debugging lohm-calculator.js');

var fluid_type = '';
var emptyFieldsHighlighted = false;

// Calculate Lohms in Product finder 
$('.calculate_lohms').click(function(event){
	event.preventDefault();
	debug__lohm_calculator('calculating lohms'); 
	// Clear out lohm field in case there is already a value in it.
	$('#lohm_rate').val('');
	var placeholder = $('#select-fluid-type').find('.placeholder').text();
	// This is necessary because, if no fluid is selected, the select.val() will use the first option.
	// Checking the placeholder indicates if there is an option actually selected.
	fluid_type = (placeholder!=='Fluid Type') ? $('select[name="fluid_type"]').val() : null;
	var fluid_type_text = $('#fluid_type :selected').text();
	var temperature = parseFloat($('input[name="temperature"').val());
	var temperature_unit = $('select[name="temperature_unit"]').val();
	var flow_rate = parseFloat($('input[name="flow_rate"').val());
	var flow_rate_unit = $('select[name="flow_rate_unit"]').val();
	var upstream_pressure = parseFloat($('input[name="upstream_pressure"').val());
	var downstream_pressure = parseFloat($('input[name="downstream_pressure"').val());
	var pressure_unit = $('select[name="pressure_unit"]').val();
	
	var all_data_entered = true;
	var validateData;
		
	['temperature','flow_rate_unit','flow_rate','pressure_unit','fluid_type','upstream_pressure','downstream_pressure'].forEach(function(lohmField) {
		if (['flow_rate_unit','pressure_unit'].includes(lohmField)) {
			//validateData = $(`select[name="${lohmField}"]`).val();
			//debug__lohm_calculator(lohmField,' select value:',validateData);
			// jQuery is buggy when testing if there is a select value
			// Check Placeholder instead
			let placeholder = $(`#select-${lohmField.replace(/_/g,'-')} .placeholder`).text();
			validateData = (placeholder==='Select Unit') ? false : true;
			debug__lohm_calculator(lohmField,' Text of placeholder:',placeholder);
		} else 	{
			validateData = eval(lohmField);
		}
		let inputType = ['flow_rate_unit','pressure_unit','fluid_type'].includes(lohmField) ? 'select' : 'input';
		// 0 is a valid entry for the numeric fields
		if (validateData!==0 && !validateData) {
			if (inputType==='select' ) {
				// select-pressure-unit
				// select-flow-rate-unit
				// select-fluid-type
				$(`#select-${lohmField.replace(/_/g,'-')}`).addClass('lohm-calculator-empty-field');
				
				debug__lohm_calculator('lohmField = select:',`#select-${lohmField.replace(/_/g,'-')}`);
				emptyFieldsHighlighted = true;
			} else {
				$(`${inputType}[name="${lohmField}"]`).addClass('lohm-calculator-empty-field');
			}
			all_data_entered = false;
		} else {
			if (inputType==='select' ) {
				$(`#select-${lohmField.replace(/_/g,'-')}`).removeClass('lohm-calculator-empty-field');
			} else {
				$(`${inputType}[name="${lohmField}"]`).removeClass('lohm-calculator-empty-field');
			}
		}
	});
	
	if (downstream_pressure >= upstream_pressure) {
		all_data_entered = false;
		alert('Upstream Pressure must be greater than Downstream Pressure.');
	}

	all_data_entered = (all_data_entered) ? validate_temp_limits(temperature,temperature_unit,fluid_type,fluid_type_text) : false;
		
	if (!all_data_entered) {
		debug__lohm_calculator('all data not entered.');
		$('#lohm_enter_data').addClass('lohm-calculator-red');
		return false;
	} else {
		$('#lohm_enter_data').removeClass('lohm-calculator-red');
	}
	
	// Adding in psig
	// -- must convert to psia because all gas reference data is in psia	
	if (pressure_unit==='psig') {
		debug__lohm_calculator('converting psig to psia, initial values upstream_pressure',upstream_pressure,'downstream_pressure',downstream_pressure);
		downstream_pressure = convert_psig_to_psia(downstream_pressure);
		upstream_pressure = convert_psig_to_psia(upstream_pressure);
		debug__lohm_calculator('changed pressure unit to psia, converted values upstream_pressure',upstream_pressure,'downstream_pressure',downstream_pressure);
		pressure_unit = 'psia';
	}
	
	// Get product type
	// -- For product finder, it is available in control
	// -- For the modals - this is needed only for Restrictors (to calculate V Factor)
	
	var product_type_id = (control && control['product_type_id']) ? control['product_type_id'] : null;
	
	debug__lohm_calculator('calculating lohms fluid_type',fluid_type,'temperature',temperature,'temperature_unit',temperature_unit,'flow_rate',flow_rate,'flow_rate_unit',flow_rate_unit,'pressure_unit',pressure_unit,'upstream_pressure',upstream_pressure,'downstream_pressure',downstream_pressure);
	
	// determine gas or liquid.
	var result = (fluid_type in gas_units_k) ? 
		calculate_gas_lohm_rate(fluid_type,upstream_pressure,downstream_pressure,flow_rate,pressure_unit,flow_rate_unit,temperature,temperature_unit)  : 
		calculate_liguid_lohm_rate(fluid_type,upstream_pressure,downstream_pressure,flow_rate,product_type_id,pressure_unit,flow_rate_unit,temperature,temperature_unit);

	debug__lohm_calculator(`result for fluid_type ${fluid_type}`,result);
	// Lee - round to 3 decimal points
	var lohms = +result.lohms.toFixed(3);
				
	debug__lohm_calculator('****CALCULATED lohms:',lohms);
	$('input[name="lohm_rate"]').val(lohms);
});

var calculate_liguid_lohm_rate = function (
		fluid_type,
		upstream_pressure,
		downstream_pressure,
		flow_rate,
		product_type_id=null,
		pressure_unit,
		flow_rate_unit,
		temperature,
		temperature_unit,
		solve_for=null,
		specific_gravity=null,
		viscosity=null,
		lohms_user_value=null,
		v_factor=null
	) {
	
	/*
	
	THH Handbook - lohm calculations FOR LIQUID page O9 (letter 0+9) == GOTO PAGE 727 == section O starts on page 720
	
	Liquid VOLUMETRIC
	L = Lohm rate (Lohms)
	H = Differential pressure
	I = Liquid flow rate: Volumetric
	S = Specific gravity* (see page O16)
		This is a graph of specific gravity vs temperature for a variety of liquids.
		Q: What to choose here? 
		Q: Should temperature be kept in and a type of liquid added?
		
	V = Viscosity compensation factor** (see page O13) 
	w = Liquid flow rate: Gravimetric
	K = Units Constant – Liquid (see page O10)
	
	* S = 1.0 for water at 80°F. ** V = 1.0 for water at 80°F.
	
	*/
	
	debug__lohm_calculator(
		`calculate_liguid_lohm_rate
		fluid_type ${fluid_type}
		upstream_pressure ${upstream_pressure}
		downstream_pressure ${downstream_pressure}
		pressure_unit ${pressure_unit}
		flow_rate ${flow_rate}
		flow_rate_unit ${flow_rate_unit}
		product_type_id ${product_type_id}
		temperature ${temperature}
		temperature_unit ${temperature_unit}
		solve_for ${solve_for}
		specific_gravity ${specific_gravity}
		viscosity ${viscosity}
		lohms_user_value ${lohms_user_value}
		v_factor ${v_factor}`
	);
	
	// Set default as solving for lohms
	solve_for = (solve_for) ? solve_for : 'lohms';
		
	var group1, group2, result;
			
	// Volumetric or Gravimeteric
	var calculation_type = liquid_units_k[flow_rate_unit]['type'];

	debug__lohm_calculator('*****liquid_lohms calculation_type',calculation_type);
	
	// Specific Gravity
	// -- Calculate unless the user has entered specific gravity and selected "Other" liquid
	specific_gravity = (specific_gravity && fluid_type==='other') ? specific_gravity : calculate_specific_gravity(fluid_type, temperature, temperature_unit);
	
	debug__lohm_calculator('specific_gravity',specific_gravity);
	
	if (solve_for !== 'pressure') {
		// solving for pressure treated separately
		// - pass v_factor to calculate viscosity in those cases where v_factor has been manually entered.
		result = calculate_v_factor(fluid_type, temperature, temperature_unit, upstream_pressure, downstream_pressure, pressure_unit, viscosity, v_factor);
		
		// Handle the error from too low a pressure difference
		if (result===false) {
			debug__lohm_calculator('calculate_v_factor has returned false',result);
			return false;
		}

		// Lee has confirmed that we **should** be calculating v-factor
		// -- the following line is the temporary change to using a default of 1 for v_factor, except for restrictors (product_type_id 53)
		// -- keep this line commented out in case the default should be reverted to at some point in the future
		// v_factor = (v_factor) ? v_factor : (product_type_id === 53) ? result.v_factor : 1
		v_factor = (v_factor) ? v_factor : result.v_factor;
		// Keep entered viscosity if it has been entered for an "Other" liquid
		viscosity = (viscosity) ? viscosity : result.viscosity;
	}

	// Example units_constant_k: liquid_units_k["PPH"]["bar"]);
	var units_constant_k = liquid_units_k[flow_rate_unit][pressure_unit];
	debug__lohm_calculator('liquid_lohms flow_rate_unit',flow_rate_unit,'pressure_unit',pressure_unit,'units_constant_k',units_constant_k,' v_factor',v_factor);
	
	/*
	
		Fields matching excel formula
		D7 = specifc gravity
		D8 = Units Constant K
		D9 = V-Factor
		D10 = upstream pressure
		D11 = downstream pressure
		D12 = flow_rate
		
		Volumetric:
		(D8*D9/D12)*(SQRT((D10-D11)/D7))
		
		Gravimetric:
		(M8*M9/M12)*(SQRT((M10-M11)*M7))
		group1 = D8*D9/D12
		group2 = (type==='volumetric') ? (D10-D11)/D7 : (D10-D11)*D7
		(group1)*(SQRT(group2))
	
	*/
	
	switch (solve_for) {
		case 'lohms':
			debug__lohm_calculator('SOLVING FOR lohms flow_rate',flow_rate,'units_constant_k',units_constant_k,'v_factor',v_factor);
			group1 = (units_constant_k * v_factor/flow_rate);
			group2 = (calculation_type==='volumetric') ? (upstream_pressure - downstream_pressure)/specific_gravity : (upstream_pressure - downstream_pressure) * specific_gravity;
			
			debug__lohm_calculator('group1 units_constant_k * v_factor/flow_rate',group1);
			if (calculation_type==='volumetric') {
				debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream)/specific gravity',group2);
			} else {
				debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream) * specific gravity',group2);
			}
			var lohms = group1 * Math.sqrt(group2);
			debug__lohm_calculator(`v_factor ${+result.v_factor.toFixed(3)} lohms ${lohms} rounded ${+lohms.toFixed(3)}`);
			// Round lohms to 3 decimals and remove trailing 0s
			// -- return object for use with standalone calculator
			return {
				lohms: +lohms.toFixed(3),
				v_factor: +v_factor.toFixed(3),
				specific_gravity: specific_gravity,
				viscosity: viscosity
			};
			break;
		case 'flow-rate':
			// lohms = group1 * Math.sqrt(group2);
			// group1 = (units_constant_k * v_factor/flow_rate);
			// flow_rate =  (units_constant_k * v_factor) / group1
			// -- solve for group 1
			// -- then solve for flow rate

			group2 = (calculation_type==='volumetric') ? (upstream_pressure - downstream_pressure)/specific_gravity : (upstream_pressure - downstream_pressure) * specific_gravity;
			
			debug__lohm_calculator('SOLVING FOR flow_rate lohms',lohms_user_value,'units_constant_k',units_constant_k,'v_factor',v_factor,'group 2',group2);
			
			group1 = lohms_user_value / Math.sqrt(group2);
			debug__lohm_calculator('group1',group1)
		
			flow_rate = (units_constant_k * v_factor) / group1;
			debug__lohm_calculator(`flow_rate in ${flow_rate_unit}: ${flow_rate}`);
						
			return {
				flow_rate: flow_rate,
				v_factor: +v_factor.toFixed(3),
				specific_gravity: specific_gravity,
				viscosity: viscosity
			};
			break;
		case 'pressure':
			debug__lohm_calculator('SOLVING FOR pressure lohms',lohms_user_value,'flow_rate',flow_rate,'units_constant_k',units_constant_k,'specific_gravity',specific_gravity);

			result = calculate_upstream_pressure_from_lohms(
				fluid_type,
				downstream_pressure,
				pressure_unit,
				temperature,
				temperature_unit,
				lohms_user_value,
				flow_rate,
				units_constant_k,
				specific_gravity,
				viscosity,
				calculation_type,
				v_factor); 	
			
			debug__lohm_calculator('pressure calculation result:',result);

			// Round lohms to 3 decimals and remove trailing 0s
			// -- return object for use with standalone calculator
			
			// Handle error if passed up from calculate_upstream_pressure_from_lohms
			if (result === false) {
				return false;
			} else {
				return {
					upstream_pressure: +result.upstream_pressure.toFixed(3),
					v_factor: +result.v_factor.toFixed(3),
					specific_gravity: specific_gravity,
					viscosity: +result.viscosity.toFixed(3)
				};
			}
			break;
	}	
	
}

// FOR STANDALONE CALCULATOR
// -- Calculate Upstream Pressure
var calculate_upstream_pressure_from_lohms = function (
		fluid_type,
		downstream_pressure,
		pressure_unit,
		temperature,
		temperature_unit,
		lohms_user_value,
		flow_rate,
		units_constant_k,
		specific_gravity,
		viscosity,
		calculation_type,
		v_factor=null 	
	) {

	// Lee instructed us to use a first value of 25 (psid) for differential pressure when solving for pressure
	// -- Start with a temporary differential pressure value of 25
	// This is the TEMPORARY VALUE of upstream_pressure as a starting point
	var temporary_pressure = downstream_pressure + 25;
	var attempt = 1;
	var result, group1, group2, group2_sqrt, differential_pressure, absolute_value, calculated_pressure;
	var manual_v_factor = v_factor;
	
	debug__lohm_calculator('units_constant_k',units_constant_k,'flow_rate',flow_rate,'specific_gravity',specific_gravity);
	while (attempt < 500) {
		// We are solving for upstream_pressure
		// -- we're cycling through with testing upstream_pressure as a temporary_pressure, 
		// -- incrementing it each cycle with the newly calculated differential pressure
		
		debug__lohm_calculator(' ');
		debug__lohm_calculator('@@@ Before calculate_v_factor');
		debug__lohm_calculator(`attempt ${attempt} fluid_type ${fluid_type} temperature ${temperature} temperature_unit ${temperature_unit} temporary_pressure ${temporary_pressure} downstream_pressure ${downstream_pressure} pressure_unit ${pressure_unit} viscosity ${viscosity}`);
		// Pass manual v_factor ONLY
		// - this should calculate v_factor unless a manual value has been enterred
		result = calculate_v_factor(fluid_type, temperature, temperature_unit, temporary_pressure, downstream_pressure, pressure_unit, viscosity, manual_v_factor);

		// Handle the error from too low a pressure difference
		if (result===false) {
			debug__lohm_calculator('calculate_v_factor has returned false',result);
			return false;
		}
		
		debug__lohm_calculator(`@@@ after calculate_v_factor result.v_factor: ${result.v_factor} v_factor: ${v_factor} manual_v_factor: ${manual_v_factor}`);

		// Keep entered v_factor, if that exists
		v_factor = (manual_v_factor) ? manual_v_factor : result.v_factor;
		
		// Keep entered viscosity if it has been entered for an "Other" liquid.
		// Even if there wasn't a viscosity entered, the calculated value won't change
		// on further attempts.
		viscosity = (viscosity) ? viscosity : result.viscosity;

		debug__lohm_calculator('attempt',attempt,'temporary_pressure',temporary_pressure,'v_factor',v_factor,'viscosity',viscosity);

		if (v_factor === 0 || v_factor === Number.NEGATIVE_INFINITY) {
			debug__lohm_calculator(`error v_factor: ${v_factor}`);
			alert('Error calculating V-Factor. Please enter it manually.');			
			return false;
		}

		group1 = (units_constant_k * v_factor/flow_rate);
		
		// Solve for group 2
		// lohms_user_value = group1 * Math.sqrt(group2);
		group2_sqrt = lohms_user_value / group1;
		group2 = group2_sqrt ** 2;

		if (calculation_type==='volumetric') {
			// group2 = (upstream_pressure - downstream_pressure)/specific_gravity ; 
			differential_pressure = group2 * specific_gravity;
		} else {
			// group2 = (upstream_pressure - downstream_pressure) * specific_gravity ;
			differential_pressure = group2 / specific_gravity;
		}

		// THIS WAS THE INSTRUCTION IN EARLY OCTOBER
		// absolute_value = Math.abs(differential_pressure - temporary_pressure) / temporary_pressure;
		// THIS IS THE INSTRUCTION NOV 12
		// (absolute value (calculated pressure (#2) – temporary pressure))/Temporary pressure 
		calculated_pressure = downstream_pressure + differential_pressure;
		absolute_value = Math.abs(calculated_pressure - temporary_pressure) / temporary_pressure;
				
		debug__lohm_calculator('calculation_type',calculation_type,'group1 units_constant_k * v_factor/flow_rate',group1,'group2',group2,'differential_pressure',differential_pressure,'calculated_pressure',calculated_pressure,'absolute_value',absolute_value);
		
		if (absolute_value < .005) {
			debug__lohm_calculator(`*****SETTING UPSTREAM ABSOLUTE VALUE is <= .005 ${absolute_value} upstream pressure is calculated_pressure ${calculated_pressure}`);
			break;
		} else {
			// Continue with another attempt
			// THIS WAS THE INSTRUCTION IN EARLY OCTOBER
			//temporary_pressure = (differential_pressure + temporary_pressure) / 2;
			// THIS IS THE INSTRUCTION NOV 12
			temporary_pressure = (calculated_pressure + temporary_pressure) / 2;
			debug__lohm_calculator(`Next attempt with new temporary_presure ${temporary_pressure}`);
		}
		
		attempt++;
		
	}
	
	return {
		upstream_pressure: calculated_pressure,
		v_factor: v_factor,
		viscosity: viscosity
	}
	
}		
/*

	END: CALCULATING UPSTREAM PRESSURE FROM LOHMS

*/

/*

CALCULATING LIQUID FLOW RATE FROM LOHMS

*/

var calculate_liguid_flow_rate_from_lohms = function (fluid_type,upstream_pressure,downstream_pressure,pressure_unit,temperature,temperature_unit,lohms) {
	
	// WHAT IS DIFFERENT HERE?
	// -- lohms are supplied
	// -- SOLVE FOR flow_rate
	// -- HAVE TO SET A flow_rate UNIT as default -- WHICH ONE?
	
	var flow_rate_unit = 'gpm';
	/*
	
	THH Handbook - lohm calculations FOR LIQUID page O9 (letter 0+9) == GOTO PAGE 727 == section O starts on page 720
	
	Liquid VOLUMETRIC
	L = Lohm rate (Lohms)
	H = Differential pressure
	I = Liquid flow rate: Volumetric
	S = Specific gravity* (see page O16)
		This is a graph of specific gravity vs temperature for a variety of liquids.
		Q: What to choose here? 
		Q: Should temperature be kept in and a type of liquid added?
		
	V = Viscosity compensation factor** (see page O13) 
	w = Liquid flow rate: Gravimetric
	K = Units Constant – Liquid (see page O10)
	
	* S = 1.0 for water at 80°F. ** V = 1.0 for water at 80°F.
	
	*/
	
	debug__lohm_calculator(
		"fluid_type",fluid_type,
		"upstream_pressure",upstream_pressure,
		"downstream_pressure",downstream_pressure,
		"pressure_unit",pressure_unit,
		"flow_rate_unit",flow_rate_unit,
		"temperature",temperature,
		"temperature_unit",temperature_unit,
		"lohms",lohms
	);
			
	// Volumetric or Gravimeteric
	var calculation_type = liquid_units_k[flow_rate_unit]['type'];

	debug__lohm_calculator('liquid_lohms calculation_type',calculation_type);
	
	// Specific Gravity
	var specific_gravity = calculate_specific_gravity(fluid_type, temperature, temperature_unit);
	debug__lohm_calculator('specific_gravity',specific_gravity);
	
	// V Factor (Viscosity compensation factor)
	// -- the spreadsheet says this = 1 unless calculating for restrictors
	// -- 1 is for Water at 80 degrees
	
	// There is a V Factor calculations to do for "single orifice restrictors"
	// -- otherwise, V Factor = 1
	
	// UPDATE: Lee says we should use the default V Factor for all
	// -- I am keeping the calculate_v_factor in this code
	// -- It can be used if a product type was added to the calculator
	// var v_factor = (product_type_id === 53) ? calculate_v_factor(fluid_type, temperature, temperature_unit,upstream_pressure, downstream_pressure, pressure_unit) : 1;
	
	// Using default:
	var v_factor = 1;

	//flow_rate_unit - pressure_unit: liquid_units_k["PPH"]["bar"]);
	var units_constant_k = liquid_units_k[flow_rate_unit][pressure_unit];
	debug__lohm_calculator('liquid_lohms flow_rate_unit',flow_rate_unit,'pressure_unit',pressure_unit,'units_constant_k',units_constant_k,'using default v_factor',v_factor);
	
	/*
	
		Fields matching excel formula
		D7 = specifc gravity
		D8 = Units Constant K
		D9 = V-Factor
		D10 = upstream pressure
		D11 = downstream pressure
		D12 = flow_rate
		
		Volumetric:
		(D8*D9/D12)*(SQRT((D10-D11)/D7))
		
		Gravimetric:
		(M8*M9/M12)*(SQRT((M10-M11)*M7))
		group1 = D8*D9/D12
		group2 = (type==='volumetric') ? (D10-D11)/D7 : (D10-D11)*D7
		(group1)*(SQRT(group2))
	
	*/

	if (calculation_type==='volumetric') {
		debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream)/specific gravity',group2);
	} else {
		debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream) * specific gravity',group2);
	}
	
	// lohms = group1 * Math.sqrt(group2);
	// group1 = (units_constant_k * v_factor/flow_rate);
	// -- solve for group 1
	// -- then solve for flow rate
	var group2 = (calculation_type==='volumetric') ? (upstream_pressure - downstream_pressure)/specific_gravity : (upstream_pressure - downstream_pressure) * specific_gravity;
	
	var group1 = lohms / Math.sqrt(group2);
	debug__lohm_calculator('group1',group1)

	var flow_rate = group1 / (units_constant_k * v_factor);
	debug__lohm_calculator('flow_rate in gpm',flow_rate);
	
	var group1 = (units_constant_k * v_factor/flow_rate);
	
	// Round to 2 decimals and remove trailing 0s
	return +flow_rate.toFixed(3);
	
}


/*

END OF CALCULATING LIQUID FLOW RATE FROM LOHMS

*/

/*

CALCULATING LIQUID PRESSURE FROM LOHMS
TEMP CODE

*/

var calculate_liguid_pressure_from_lohms = function (fluid_type,flow_rate,flow_rate_unit,temperature,temperature_unit) {
	
	var pressure_unit = 'psi';
	/*
	
	THH Handbook - lohm calculations FOR LIQUID page O9 (letter 0+9) == GOTO PAGE 727 == section O starts on page 720
	
	Liquid VOLUMETRIC
	L = Lohm rate (Lohms)
	H = Differential pressure
	I = Liquid flow rate: Volumetric
	S = Specific gravity* (see page O16)
		This is a graph of specific gravity vs temperature for a variety of liquids.
		Q: What to choose here? 
		Q: Should temperature be kept in and a type of liquid added?
		
	V = Viscosity compensation factor** (see page O13) 
	w = Liquid flow rate: Gravimetric
	K = Units Constant – Liquid (see page O10)
	
	* S = 1.0 for water at 80°F. ** V = 1.0 for water at 80°F.
	
	*/
	
	debug__lohm_calculator(
		"fluid_type",fluid_type,
		"pressure_unit",pressure_unit,
		"flow_rate",flow_rate,
		"flow_rate_unit",flow_rate_unit,
		"product_type_id",product_type_id,
		"temperature",temperature,
		"temperature_unit",temperature_unit,
		"lohms",lohms
	);
			
	// Volumetric or Gravimeteric
	var calculation_type = liquid_units_k[flow_rate_unit]['type'];

	debug__lohm_calculator('liquid_lohms calculation_type',calculation_type);
	
	// Specific Gravity
	var specific_gravity = calculate_specific_gravity(fluid_type, temperature, temperature_unit);
	debug__lohm_calculator('specific_gravity',specific_gravity);
	
	// V Factor (Viscosity compensation factor)
	// -- the spreadsheet says this = 1 unless calculating for restrictors
	// -- 1 is for Water at 80 degrees
	
	// There is a V Factor calculations to do for "single orifice restrictors"
	// -- otherwise, V Factor = 1
	
	// UPDATE: Lee says we should use the default V Factor for all
	// -- I am keeping the calculate_v_factor in this code
	// -- It can be used if a product type was added to the calculator
	// var v_factor = (product_type_id === 53) ? calculate_v_factor(fluid_type, temperature, temperature_unit,upstream_pressure, downstream_pressure, pressure_unit) : 1;
	
	// Using default:
	var v_factor = 1;

	//flow_rate_unit - pressure_unit: liquid_units_k["PPH"]["bar"]);
	var units_constant_k = liquid_units_k[flow_rate_unit][pressure_unit];
	debug__lohm_calculator('liquid_lohms flow_rate_unit',flow_rate_unit,'pressure_unit',pressure_unit,'units_constant_k',units_constant_k,'using default v_factor',v_factor);
	
	/*
	
		Fields matching excel formula
		D7 = specifc gravity
		D8 = Units Constant K
		D9 = V-Factor
		D10 = upstream pressure
		D11 = downstream pressure
		D12 = flow_rate
		
		Volumetric:
		(D8*D9/D12)*(SQRT((D10-D11)/D7))
		
		Gravimetric:
		(M8*M9/M12)*(SQRT((M10-M11)*M7))
		group1 = D8*D9/D12
		group2 = (type==='volumetric') ? (D10-D11)/D7 : (D10-D11)*D7
		(group1)*(SQRT(group2))
	
	*/

	if (calculation_type==='volumetric') {
		debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream)/specific gravity',group2);
	} else {
		debug__lohm_calculator('calculation_type',calculation_type,'group2 (upstream-downstream) * specific gravity',group2);
	}
	
	// lohms = group1 * Math.sqrt(group2);
	// group2 = (calculation_type==='volumetric') ? (upstream_pressure - downstream_pressure)/specific_gravity :(upstream_pressure - downstream_pressure) * specific_gravity;
	// -- solve for group 2
	// -- then solve for pressure difference
	var group1 = (units_constant_k * v_factor/flow_rate);

	var group2 = Math.pow((lohms/group1), 2);  
	
	var pressure_difference = (calculation_type==='volumetric') ? group2 * specific_gravity : group2 / specific_gravity

	onsole.log('pressure_difference',pressure_difference);

	// Round to 2 decimals and remove trailing 0s
	return +pressure_difference.toFixed(3);

	
}


/*

END OF CALCULATING LIQUID PRESSURE FROM LOHMS

*/

var calculate_gas_lohm_rate = function (
		fluid_type,
		upstream_pressure,
		downstream_pressure,
		flow_rate,
		pressure_unit,
		flow_rate_unit,
		temperature,
		temperature_unit,
		solve_for=null,
		lohms_user_value=null
	) {

	// Default solve_for is lohms
	// -- this is also required for the product finder lohm calculator
	solve_for = (solve_for) ? solve_for : 'lohms';
		
	// volumetric or gravimeteric
	var calculation_type = ( gas_flow_units['volumetric'].includes(flow_rate_unit) ) ? 'volumetric' : 'gravimetric';
	debug__lohm_calculator('calculate_gas_lohm_rate fluid_type:',fluid_type,'pressure_unit:',pressure_unit,'flow_rate_unit:',flow_rate_unit);
	var units_constant_k = gas_units_k[fluid_type][pressure_unit][flow_rate_unit];

	if (units_constant_k == null) {
		debug__lohm_calculator(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);

		alert(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);
		return false;
	}
	
	debug__lohm_calculator('calculate calculation_type',calculation_type,'units_constant_k',units_constant_k);
		
	/*
	
		There is either the sonic or the subsonic equation.
		
		If Upstream/Downstream >= 1.9, use the sonic equation
		Otherwise use the subsonic equation
		
		These are the values needed for the calculations
		
		K = units_constant_k
		Ft = temperature correction factor (SEE PAGE 031 and below)
		P1 - upstream_pressure
		P2 = downstream_pressure
		Q = gas flow rate = flow_rate
		QUESTION: How does flow_rate have to be converted based on the units?
		-- Is it to Liters / minutes?
		
	*/
	
	// Convert temperature to Fahrenheit
	temperature = (temperature_unit==='F') ?  temperature : convert_to_fahrenheit(temperature);

	var temp_correction_factor = Math.sqrt( 530 / (temperature + 460));
	
	debug__lohm_calculator('temperature in F',temperature,'temp_correction_factor',temp_correction_factor);
	debug__lohm_calculator('upstream_pressure/downstream_pressure',upstream_pressure/downstream_pressure);

	/*
		pressure and flow rate DO NOT have to be converted.
		-- This is what units_constant_k is for.
	*/
	
	switch (solve_for) {
		case 'lohms':
			debug__lohm_calculator('Solving for lohms');
			// Sonic equations
			if (downstream_pressure===0 || (downstream_pressure > 0 && upstream_pressure/downstream_pressure >= 1.9)) {
				// Sonic equation
				debug__lohm_calculator('sonic equation units_constant_k',units_constant_k,'temp_correction_factor',temp_correction_factor,'upstream_pressure',upstream_pressure,'flow_rate',flow_rate);
				// lohms = K * Ft * P1 / flow_rate
				var lohms = ( units_constant_k * temp_correction_factor * upstream_pressure ) / flow_rate;
			} else {
				// Subsonic equation
				debug__lohm_calculator('Subsonic equation');
				// lohms = 2 * K * Ft * (square root of delta Pressure * downstream pressure) / flow_rate
				var delta_pressure = upstream_pressure - downstream_pressure;
				var pressure_sqrt = Math.sqrt( delta_pressure * downstream_pressure );
				var lohms = (2 * units_constant_k * temp_correction_factor * pressure_sqrt ) / flow_rate;
				
				debug__lohm_calculator('calcualting gas delta_pressure',delta_pressure,'pressure_sqrt',pressure_sqrt,'units_constant_k',units_constant_k,'temp_correction_factor',temp_correction_factor,'flow_rate',flow_rate,'lohms',lohms)
			}
			
			return {
				lohms: lohms,
				units_constant_k: units_constant_k
			}
			break;

		case 'flow-rate':
			debug__lohm_calculator('Solving for flow-rate');
			// Sonic equations
			if (downstream_pressure === 0 || (downstream_pressure > 0 && upstream_pressure/downstream_pressure >= 1.9)) {
				debug__lohm_calculator('sonic equation');
				// Sonic equation
				// lohms = K * Ft * P1 / flow_rate
				debug__lohm_calculator('sonic equation units_constant_k',units_constant_k,'temp_correction_factor',temp_correction_factor,'upstream_pressure',upstream_pressure,'lohms_user_value',lohms_user_value);

				flow_rate = ( units_constant_k * temp_correction_factor * upstream_pressure ) / lohms_user_value;
				debug__lohm_calculator('sonic equation flow_rate',flow_rate);
			} else {
				debug__lohm_calculator('Subsonic equation');
				// Subsonic equation
				// lohms = 2 * K * Ft * (square root of delta Pressure * downstream pressure) / flow_rate
				var delta_pressure = upstream_pressure - downstream_pressure;
				var pressure_sqrt = Math.sqrt( delta_pressure * downstream_pressure );
				flow_rate = ( 2 * units_constant_k * temp_correction_factor * pressure_sqrt ) / lohms_user_value;
				
				debug__lohm_calculator('calcualting gas flow_rate',flow_rate,'pressure_sqrt',pressure_sqrt,'units_constant_k',units_constant_k,'temp_correction_factor',temp_correction_factor)
			}
			
			debug__lohm_calculator('calcualting gas flow_rate',flow_rate)
			
			return {
				flow_rate: flow_rate,
				units_constant_k: units_constant_k
			}
			break;

		case 'pressure':
			debug__lohm_calculator('Solving for pressure');
/*
Solve upstream pressure using the sonic equation. Then take the calculated upstream pressure to downstream pressure ratio and compare it to 1.9. If greater than or equal to, then display the sonic equation result. If it is less than 1.9, recalculate upstream pressure with the subsonic equation and display that result. 
*/
			debug__lohm_calculator('sonic equation units_constant_k',units_constant_k,'temp_correction_factor',temp_correction_factor,'downstream_pressure',downstream_pressure,'pressure_unit',pressure_unit,'flow_rate',flow_rate);
			// lohms = ( units_constant_k * temp_correction_factor * upstream_pressure ) / flow_rate;
			// Start with sonic equation
			upstream_pressure = ( lohms_user_value * flow_rate ) / ( units_constant_k * temp_correction_factor )
			var difpressure = upstream_pressure/downstream_pressure;
			debug__lohm_calculator('sonic equation upstream_pressure',upstream_pressure,'upstream_pressure/downstream_pressure',difpressure);
			if (upstream_pressure/downstream_pressure < 1.9) {
				debug__lohm_calculator('Switching to subsonic equation');

				// reverse these steps
				// var delta_pressure = upstream_pressure - downstream_pressure;
				// var pressure_sqrt = Math.sqrt( delta_pressure * downstream_pressure );
				// var lohms = (2 * units_constant_k * temp_correction_factor * pressure_sqrt ) / flow_rate;
				var pressure_sqrt = ( lohms_user_value * flow_rate ) / ( 2 * units_constant_k * temp_correction_factor );
				var delta_x_downstream = pressure_sqrt ** 2;
				var delta_pressure = delta_x_downstream / downstream_pressure;
				upstream_pressure = downstream_pressure + delta_pressure;
				debug__lohm_calculator('subsonic equation upstream_pressure',upstream_pressure,'pressure_sqrt',pressure_sqrt,'delta_x_downstream',delta_x_downstream,'delta_pressure',delta_pressure);
			}
						
			return {
				upstream_pressure: upstream_pressure,
				units_constant_k: units_constant_k
			}
			break;
					
	}
}

/*

CALCULATE GAS flow rate using lohms
TMP CODE

*/

var calculate_gas_flow_rate_from_lohms = function (fluid_type,upstream_pressure,downstream_pressure,pressure_unit,temperature,temperature_unit, lohms) {

	// set default unit
	var flow_rate_unit = 'SLPM';
	
	// volumetric or gravimeteric
	var calculation_type = ( gas_flow_units['volumetric'].includes(flow_rate_unit) ) ? 'volumetric' : 'gravimetric';
	debug__lohm_calculator('calculate_gas_lohm_rate fluid_type:',fluid_type,'pressure_unit:',pressure_unit,'flow_rate_unit:',flow_rate_unit);
	var units_constant_k = gas_units_k[fluid_type][pressure_unit][flow_rate_unit];
		
	// FOR DEVELOPMENT ONLY
	if (units_constant_k == null) {
		debug__lohm_calculator(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);
		debug__lohm_calculator(`gas_units_k[${fluid_type}][${pressure_unit}]`,gas_units_k[fluid_type][pressure_unit]);

		alert(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);
		return false;
	}
	
	debug__lohm_calculator('calculate calculation_type',calculation_type,'units_constant_k',units_constant_k);
		
	/*
	
		There is either the sonic or the subsonic equation.
		
		If Upstream/Downstream >= 1.9, use the sonic equation
		Otherwise use the subsonic equation
		
		These are the values needed for the calculations
		
		K = units_constant_k
		Ft = temperature correction factor (SEE PAGE 031 and below)
		P1 - upstream_pressure
		P2 = downstream_pressure
		Q = gas flow rate = flow_rate
		QUESTION: How does flow_rate have to be converted based on the units?
		-- Is it to Liters / minutes?
		
	*/
	
	// Convert temperature to Fahrenheit
	temperature = (temperature_unit==='F') ?  temperature : convert_to_fahrenheit(temperature);

	var temp_correction_factor = Math.sqrt( 530 / (temperature + 460));
	
	debug__lohm_calculator('temperature in F',temperature,'temp_correction_factor',temp_correction_factor);
	debug__lohm_calculator('upstream_pressure/downstream_pressure',upstream_pressure/downstream_pressure);
	/*
	
		UPDATE: pressure and flow rate DO NOT have to be converted.
		-- This is what the units_constant_k is for.
	*/
	
	/*
	
		****** TO DO HERE TO GET FLOW RATE
		****** JUST REVERSE THE TWO lohm equations below and and get the flow rate
		
	*/
	
	// Sonic equations
	if (downstream_pressure===0 || (downstream_pressure > 0 && upstream_pressure/downstream_pressure >= 1.9)) {
		// Sonic equation
		debug__lohm_calculator('sonic equation');
		// lohms = K * Ft * P1 / flow_rate
		var lohms = ( units_constant_k * temp_correction_factor * upstream_pressure ) / flow_rate;
	} else {
		// Subsonic equation
		debug__lohm_calculator('Subsonic equation');
		// lohms = 2 * K * Ft * (square root of delta Pressure * downstream pressure) / flow_rate
		var delta_pressure = upstream_pressure - downstream_pressure;
		var pressure_sqrt = Math.sqrt( delta_pressure * downstream_pressure );
		var lohms = (2 * units_constant_k * temp_correction_factor * pressure_sqrt ) / flow_rate
	}
	
	return flow_rate;
}

/*

END OF CALCULATE GAS FLOW RATE FROM LOHMS

*/


/*

CALCULATING GAS PRESSURE FROM LOHMS

*/

var calculate_gas_pressure_from_lohms = function (fluid_type,flow_rate,flow_rate_unit,temperature,temperature_unit,lohms) {

	// set default unit
	var pressure_unit = 'psi';
	
	// volumetric or gravimeteric
	var calculation_type = ( gas_flow_units['volumetric'].includes(flow_rate_unit) ) ? 'volumetric' : 'gravimetric';
	debug__lohm_calculator('calculate_gas_lohm_rate fluid_type:',fluid_type,'pressure_unit:',pressure_unit,'flow_rate_unit:',flow_rate_unit);
	var units_constant_k = gas_units_k[fluid_type][pressure_unit][flow_rate_unit];
		
	// FOR DEVELOPMENT ONLY
	if (units_constant_k == null) {
		debug__lohm_calculator(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);
		debug__lohm_calculator(`gas_units_k[${fluid_type}][${pressure_unit}]`,gas_units_k[fluid_type][pressure_unit]);

		alert(`gas_units_k has no entry for ${fluid_type} pressure_unit: ${pressure_unit} flow_rate_unit: ${flow_rate_unit}`);
		return false;
	}
	
	debug__lohm_calculator('calculate calculation_type',calculation_type,'units_constant_k',units_constant_k);
		
	/*
	
		There is either the sonic or the subsonic equation.
		
		If Upstream/Downstream >= 1.9, use the sonic equation
		Otherwise use the subsonic equation
		
		These are the values needed for the calculations
		
		K = units_constant_k
		Ft = temperature correction factor (SEE PAGE 031 and below)
		P1 - upstream_pressure
		P2 = downstream_pressure
		Q = gas flow rate = flow_rate
		QUESTION: How does flow_rate have to be converted based on the units?
		-- Is it to Liters / minutes?
		
	*/
	
	// Convert temperature to Fahrenheit
	temperature = (temperature_unit==='F') ?  temperature : convert_to_fahrenheit(temperature);

	var temp_correction_factor = Math.sqrt( 530 / (temperature + 460));
	
	debug__lohm_calculator('temperature in F',temperature,'temp_correction_factor',temp_correction_factor);
	debug__lohm_calculator('upstream_pressure/downstream_pressure',upstream_pressure/downstream_pressure);
	/*
	
		UPDATE: pressure and flow rate DO NOT have to be converted.
		-- This is what the units_constant_k is for.
	*/
	
	/*
	
		****** TO DO HERE TO GET PRESSURE
		****** PROBLEM: the sonic or subsonic equation determination is based on pressure supplied. How to determine which equation to use when we have lohms, temp and flow rate?
		
	*/
	
	// Sonic equations
	if (downstream_pressure===0 || (downstream_pressure > 0 && upstream_pressure/downstream_pressure >= 1.9)) {
		// Sonic equation
		debug__lohm_calculator('sonic equation');
		// lohms = K * Ft * P1 / flow_rate
		var lohms = ( units_constant_k * temp_correction_factor * upstream_pressure ) / flow_rate;
	} else {
		// Subsonic equation
		debug__lohm_calculator('Subsonic equation');
		// lohms = 2 * K * Ft * (square root of delta Pressure * downstream pressure) / flow_rate
		var delta_pressure = upstream_pressure - downstream_pressure;
		var pressure_sqrt = Math.sqrt( delta_pressure * downstream_pressure );
		var lohms = (2 * units_constant_k * temp_correction_factor * pressure_sqrt ) / flow_rate
	}
	
	return flow_rate;
}

/*

END OF CALCULATE GAS PRESSURE FROM LOHMS

*/

$('select[name="fluid_type"]').change(function() {
	debug__lohm_calculator(`Fluid Type About to be changed from: ${fluid_type}`);
	var prev_substance = (fluid_type) ? ((fluid_type in gas_units_k) ? 'gas' : 'liquid') : null;
	fluid_type = $(this).val();
	debug__lohm_calculator(`Fluid Type changed to: ${fluid_type}`);
	
	// If changing from null or between liquid and gas
	// -- Change pressure units and flow rate values based on fluid_type
	// -- Reset placeholders to "Select..."
	// -- Otherwise, leave units in place
	
	var substance = (fluid_type in gas_units_k) ? 'gas' : 'liquid';
	debug__lohm_calculator(`prev_substance: ${prev_substance} substance: ${substance}`);
	if ((substance !== prev_substance && prev_substance)|| (substance === 'gas' && prev_substance == null)) {

		var pressure_placeholder = 'Select Unit';
		var flow_placeholder = 'Select Unit';
		var temperature_placeholder = 'Select Scale';
			
		if (substance==='liquid') {
			var flow_options = `
				<option value="gpm">gpm</option>
				<option value="L/min">L/min</option>
				<option value="mL/min">mL/min</option>
				<option value="in3/min">in&#179;/min</option>
				<option value="PPH">PPH</option>
				<option value="gm/min">gm/min</option>`;
			
			var pressure_options = `
				<option value="psi">psi</option>
				<option value="bar">bar</option>
				<option value="kPa">kPa</option>
				<option value="kg/sq. cm">kg/sq. cm</option>
				<option value="mm Hg">mm Hg</option>`;
		} else {
			var flow_options = `
				<option value="SLPM">SLPM</option>
				<option value="SCFM">SCFM</option>
				<option value="in3/min">in&#179;/min</option>
				<option value="mL/min">mL/min</option>
				<option value="PPH">PPH</option>
				<option value="lbm/s">lb<sub>m</sub>/s</option>
				<option value="kg/min">kg/min</option>
				<option value="gm/min">gm/min</option>`;
	
			var pressure_options = `
				<option value="psia">psia</option>
				<option value="psig">psig</option>
				<option value="bar">bar</option>
				<option value="kPa">kPa</option>
				<option value="mm Hg">mm Hg</option>`;
		}
		
		// Set flow rate units
		$('#select-flow-rate-unit').find('.placeholder').text( flow_placeholder );
		$('select[name="flow_rate_unit"]').html( flow_options );
		
		// Set pressure units
		$('#select-pressure-unit').find('.placeholder').text( pressure_placeholder );
		$('select[name="pressure_unit"]').html( pressure_options );
		
		// Set temperature placeholder
		// -- Do not change temperature selection when switching units
		//$('#select-temperature_unit').find('.placeholder').text( temperature_placeholder );
		
		// Remove automatic value assignment
		// -- Otherwise, selecting the first option in the dropdown will not be recognized.
		$('select[name="pressure_unit"]').val('');
		$('select[name="flow_rate_unit"]').val('');
		//$('select[name="temperature_unit"]').val('');
	} 	
});

// Calculate specifc_gravity
function calculate_specific_gravity (fluid_type, temperature, temperature_unit) {
	
	if (!liquids_for_SG.hasOwnProperty(fluid_type)) {
		debug__lohm_calculator('calculate_specific_gravity NO liquids_for_SG entry for ',fluid_type);
		debug__lohm_calculator('calculate_specific_gravity returning a default of 1');
		return 1;
	}
	
	var currentLiquid = liquids_for_SG[fluid_type];
	debug__lohm_calculator('fluid_type',fluid_type,'currentLiquid',currentLiquid);
	
	var SGM = currentLiquid["SGMFunc"];
	var SGB = currentLiquid["SGBFunc"];
	// These are not used for specific gravity calculation
	// var VISCMFunc = currentLiquid["VISCMFunc"];
	// var VISCBFunc = currentLiquid["VISCBFunc"];
	// var LiqTUL = currentLiquid["SGMFLiqTULunc"];
	// var LiqTLL = currentLiquid["LiqTLL"];
	
	// temperature must be in Fahrenheit
	debug__lohm_calculator('temp and unit',temperature,temperature_unit)
	temperatureInF = (temperature_unit==='F') ?  temperature : convert_to_fahrenheit(temperature);

	// This is derived from code to create a chart, supplied by Lee.
	// I'm going to stay close to it, so Lee can help debug when needed
	
	var XCoord = ((temperatureInF + 80) / 20) * 0.603;
	debug__lohm_calculator('temp in fahrenheit',temperatureInF,'XCoord',XCoord);
	
	var specificGravity, YCoord; 
		
	// Solve for specific gravity
	switch (fluid_type) {
		case 'Water':
			debug__lohm_calculator('fluid_type is water');
			
			if (temperatureInF <= 55) {
				specificGravity = 1.001;
			} else if (temperatureInF > 55 && temperatureInF < 65) {
				specificGravity = 1.0;
			} else {
				if (XCoord < 4) {
					SGM = -0.0462;
					SGB = 4.63;
				} else if (XCoord > 6.02) {
					SGM = 0.1392;
					SGB = 5.56;
				} else {
					// Using values supplied in liquids_for_SG
				}
		 
				YCoord = (-1 * SGM * XCoord) + SGB;
				specificGravity = 0.6 + YCoord / 0.6 * 0.05;
				debug__lohm_calculator('calculated specific gravity for water:',specificGravity);
			}
			break;
	
		case 'Isopropyl Alcohol':
			debug__lohm_calculator('fluid_type is Isopropyl Alcohol');
			specificGravity = (-0.0003 * temperatureInF) + 0.8117;
			break;
			
		case 'Transaqua HT':
			debug__lohm_calculator('fluid_type is Transaqua HT');
			specificGravity = (-0.0003086 * temperatureInF) + 1.085;
			break;
	
		default:
			debug__lohm_calculator('fluid_type is default');;
			YCoord = (-1 * SGM * XCoord) + SGB;
			specificGravity = 0.6 + YCoord / 0.6 * 0.05;
			break;
	
	}
	debug__lohm_calculator('SGM',SGM,'SGB',SGB,'YCoord',YCoord);
	debug__lohm_calculator('specificGravity',specificGravity);
	return specificGravity;
};

// This function is based on the lohm calculator software.
var calculate_v_factor = function (
		fluid_type, 
		temperature, 
		temperature_unit, 
		upstream_pressure, 
		downstream_pressure, 
		pressure_unit,
		viscosity=null,
		v_factor=null
	) {
		
	if (fluid_type !== 'other' && !liquids_for_SG.hasOwnProperty(fluid_type)) {
		// This error condition should no longer be occurring
		// -- This is being left in place as a caution
		debug__lohm_calculator('calculate_specific_gravity NO liquids_for_SG entry for ',fluid_type);
		debug__lohm_calculator('calculate_specific_gravity returning a default of 1');
		return {
			v_factor: 1,
			viscosity: (viscosity) ? viscosity : null
		};
	}
	
	if (fluid_type !== 'other' && viscosity == null) {
		/*
			DETERMINE VISCOSITY
		*/
	
		var currentLiquid = liquids_for_SG[fluid_type];
		debug__lohm_calculator("currentLiquid",currentLiquid);
		
		var SGMFunc = currentLiquid["SGMFunc"];
		var SGBFunc = currentLiquid["SGBFunc"];
		var VISCMFunc = currentLiquid["VISCMFunc"];
		var VISCBFunc = currentLiquid["VISCBFunc"];
		var LiqTUL = currentLiquid["SGMFLiqTULunc"];
		var LiqTLL = currentLiquid["LiqTLL"];
		
		debug__lohm_calculator('SGMFunc',SGMFunc);
		
		// temperature must be in Fahrenheit
		debug__lohm_calculator('temp and unit',temperature,temperature_unit)
		temperatureInF = (temperature_unit==='F') ?  temperature : convert_to_fahrenheit(temperature);
		debug__lohm_calculator('temp in fahrenheit',temperatureInF);
		
		var VISCM = VISCMFunc;
		var VISCB = VISCBFunc;
		 
		switch (fluid_type) {
		
			case 'Isopropyl Alcohol':
				debug__lohm_calculator('fluid_type is Isopropyl Alcohol');
				viscosity = 1 / (0.2268891 + 
					(0.0050165382 * temperatureInF) + 
					(0.000028949845 * (temperatureInF ** 2)) - 
					(0.000000045182171 * (temperatureInF ** 3)) - 
					(0.00000000034572645 * (temperatureInF ** 4)) + 
					(0.000000000002656935 * (temperatureInF ** 5)));
				break;
				
			case 'Transaqua HT':
				debug__lohm_calculator('fluid_type is Transaqua HT');
				viscosity = ((4.3237 - (0.0030018 * temperatureInF)) / (1 + (0.014703 * temperatureInF))) ** 2;
				break;
		
			default:
				debug__lohm_calculator('fluid_type',fluid_type,'uses default');
				XCoord = 2.6891 + 
					(0.030137 * temperatureInF) - 
					(0.000042002 * (temperatureInF ** 2)) + 
					(0.000000045334 * (temperatureInF ** 3)) +
					(0.00000000032119 * (temperatureInF ** 4)) - 
					(0.0000000000014052 * (temperatureInF ** 5)) + 
					(0.0000000000000015921 * (temperatureInF ** 6));
				YCoord = (-1 * VISCM * XCoord) + VISCB;
				var YDistort = -0.0040487 + 
					(1.1884 * YCoord) - 
					(0.070371 * (YCoord ** 2)) - 
					(0.0037764 * (YCoord ** 3)) +
					(0.002823 * (YCoord ** 4)) - 
					(0.00026832 * (YCoord ** 5)) + 
					(0.0000078624 * (YCoord ** 6));
				viscosity = (0.6 * 4.571) ** (10 ** (YDistort / 9)) / 4.571;
				break;
		
		}
		
		debug__lohm_calculator(`viscosity ${viscosity}`);
	}
	
	// If v_factor has been manually entered, return viscosity and skip v-factor calculation
	if (v_factor) {
		debug__lohm_calculator('v_factor had been supplied, returning viscosity');
		return {
			v_factor: v_factor,
			viscosity: viscosity
		};
	}
	
	/*
		GET VALUES BASED ON DIFFERENTIAL PRESSURE
	*/

	if (pressure_unit !== 'psi') {
		// upstream pressure will be null if solving for pressure in standalone calculator
		upstream_pressure = (upstream_pressure) ? convert_to_psi(upstream_pressure, pressure_unit) : null;
		downstream_pressure = convert_to_psi(downstream_pressure, pressure_unit);
	}

	differential_pressure = upstream_pressure - downstream_pressure;
	
	debug__lohm_calculator(`upstream_pressure ${upstream_pressure} downstream_pressure ${downstream_pressure} differential_pressure ${differential_pressure}`);
	var PLimU, PLimL, ARStart, VFactTemp;
	
	switch (true) {
		case differential_pressure < 0.1:
			alert('Pressure difference cannot be below 0.1 psid to calculate V-Factor.');
			return false;
			break;
		case differential_pressure < 1:
			PLimU = 1;
			PLimL = 0.1;
			ARStart = 1;
			break;
		case differential_pressure < 6:
			PLimU = 6;
			PLimL = 1;
			ARStart = 2;
			break;
		case differential_pressure < 25:
			PLimU = 25;
			PLimL = 6;
			ARStart = 3;
			break;
		case differential_pressure < 100:
			PLimU = 100;
			PLimL = 25;
			ARStart = 4;
			break;
		case differential_pressure < 400:
			PLimU = 400;
			PLimL = 100;
			ARStart = 5;
			break;
		case differential_pressure < 1000:
			PLimU = 1000;
			PLimL = 400;
			ARStart = 6;
			break;
		case differential_pressure < 3000:
			PLimU = 3000;
			PLimL = 1000;
			ARStart = 7;
			break;
		case differential_pressure <= 10000:
			PLimU = 10000;
			PLimL = 3000;
			ARStart = 8;
			break;
		case differential_pressure > 10000:
			VFactTemp = 1;
			break;
		default:
			alert('Error Calculating V-Factor');
			return false;
	}
	debug__lohm_calculator('calculate v_factor differential_pressure: ',differential_pressure,
		'PLimU: ',PLimU,
		'PLimL: ',PLimL,
		'ARStart: ',ARStart,
		'VFactTemp: ',VFactTemp
	)

	// 10/28/21 - New restriction from Lee
	VFactTemp = (viscosity <= 1) ? 1 : VFactTemp;
	
	// Calculate V Factor (VFactTemp)
	// -- if not already determined
	if (!VFactTemp) {
		
		var ArNext = ARStart + 1;
		
		// Visc MUST stand for viscosity
		//var Xval = 3.35 / Math.log(10) * (Math.log(Visc) - Math.log(1));
		var Xval = 3.35 / Math.log(10) * (Math.log(viscosity) - Math.log(1));
		
		var Yval1 = DCur[ARStart][1] + (DCur[ARStart][2] * Xval) + (DCur[ARStart][3] * Xval ** 2) +
		 (DCur[ARStart][4] * Xval ** 3) + (DCur[ARStart][5] * Xval ** 4) + (DCur[ARStart][6] * Xval ** 5);
		
		var Yval2 = DCur[ArNext][1] + (DCur[ArNext][2] * Xval) + (DCur[ArNext][3] * Xval ** 2) +
		 (DCur[ArNext][4] * Xval ** 3) + (DCur[ArNext][5] * Xval ** 4) + (DCur[ArNext][6] * Xval ** 5);
		
		debug__lohm_calculator(`v_factor Xval: ${Xval} Yval1: ${Yval1} Yval2: ${Yval2}`);
		if ( (Yval1 < 0) || (Yval2 < 0) ) {
			alert('Pressure drop is too low for stated viscosity');
			return false;
		}
		 
		var YVal = Math.exp((Math.log(Yval1) + Math.log(differential_pressure / PLimL) / Math.log(PLimU / PLimL) * Math.log(Yval2 / Yval1)));
		
		VFactTemp = Math.exp((YVal / 3.34 * Math.log(10) + Math.log(0.01)));
		
		// V-Factor doesn't go above 1
		VFactTemp = (VFactTemp > 1) ? 1 : VFactTemp;
		
	}	
	
	debug__lohm_calculator('calculated v_factor = VFactTemp: ',VFactTemp);
	return {
		v_factor: VFactTemp,
		viscosity: viscosity
	};

}

$("#lohm_calculator_form").change(function() {
	debug__lohm_calculator('lohm_calculator_form has changed');
	if (emptyFieldsHighlighted) {
		clear_lohm_calculator_field_highlights();
		emptyFieldsHighlighted = false;
	}
});

function clear_lohm_calculator_field_highlights() {
	// remove the empty field highlight from all fields
	['temperature','flow_rate_unit','flow_rate','pressure_unit','fluid_type','upstream_pressure','downstream_pressure'].forEach(function(lohmField) {
		let inputType = ['flow_rate_unit','pressure_unit','fluid_type'].includes(lohmField) ? 'select' : 'input';
		if (inputType==='select' ) {
			$(`#select-${lohmField.replace(/_/g,'-')}`).removeClass('lohm-calculator-empty-field');
		} else {
			$(`${inputType}[name="${lohmField}"]`).removeClass('lohm-calculator-empty-field');
		}
	});
	$('#lohm_enter_data').removeClass('lohm-calculator-red');

}

function clearLohmVal(v,field) {
	var stripped = v.replace(/[^0-9\-\.]/g,'');
	debug__lohm_calculator('clearLohmVal v',v,stripped);
	$(`input[name=${field}]`).val(stripped)

}

function convert_to_fahrenheit(temperature) {
	return (temperature * 9)/5 + 32;
};

function convert_to_psi(pressure, pressure_unit) {
	// This is valid to convert to psi and psia
	debug__lohm_calculator(`convert_to_psi pressure_unit ${pressure_unit} pressure ${pressure}`);
	switch (pressure_unit) {
		case 'bar':
			pressure = pressure * 14.5037738;
			break;
		case 'kPa':
			pressure = pressure * .145037738;
			break;
		case 'mm Hg':
			pressure = pressure / 51.715; 
			break;
		case 'kg/sq. cm':
			pressure = pressure / 0.070306958; 
			break;
		default:
			debug__lohm_calculator('convert_to_psi ERROR with pressure_unit',pressure_unit);
	}
	debug__lohm_calculator(`convert_to_psi return psi value: ${pressure}`);

	return pressure;
};

function convert_psig_to_psia(pressure) {
	// psia = psig + 14.696704
	return pressure + 14.696704;
}

// Prevent non-numerics from being entered into the numeric fields
// - except dash and decimal
var cleanLohmField = function (thisObj) {
	debug__lohm_calculator('cleanLohmField thisObj',thisObj);
	var value = thisObj.value
	var stripped = value.replace(/[^0-9\-\.]/g,'');
	debug__lohm_calculator('cleanLohmField value', value,'stripped',stripped);
	return stripped;
}

// Standalone calculator - liquid
$('select[name="lohm_fluid_type"]').change(function() {
	debug__lohm_calculator(" lohm_fluid_type called." );
	var fluid_type = $(this).data('fluid-type');
	var fluid = $(this).val();
	debug__lohm_calculator('fluid',fluid);

	// Gas and Liquids
	// clear lohms and v_factor with each change
	$('[data-lohm-parameter-v-factor]').text('');
	$(`#lohms_${fluid_type}`).text('');

	// Toggle additional entry fields if other is or is not selected
	// Clear display only fields
	if (fluid_type==='liquid') {
		if (fluid==='other') {
			// show input fields for specific_gravity and viscosity
			// hide display for specific_gravity and viscosity
			$('[data-lohm-parameter-specific-gravity]').hide();	
			$('[data-lohm-parameter-viscosity]').hide()	;
			$('input[name="specific_gravity"]').val('');
			$('input[name="viscosity"]').val('');
			$('input[name="specific_gravity"]').removeClass('hidden');
			$('input[name="viscosity"]').removeClass('hidden');
			$('input[name="specific_gravity"]').show();
			$('input[name="viscosity"]').show();
		} else {
			// show display for specific_gravity and viscosity
			// hide and clear input fields for specific_gravity and viscosity
			$('input[name="specific_gravity"]').val('');
			$('input[name="viscosity"]').val('');
			$('input[name="specific_gravity"]').hide();
			$('input[name="viscosity"]').hide();
			$('[data-lohm-parameter-specific-gravity]').show();	
			$('[data-lohm-parameter-viscosity]').show()	;
			$('[data-lohm-parameter-specific-gravity]').text('');	
			$('[data-lohm-parameter-viscosity]').text('');
		}
	} else {
		$('[data-lohm-parameter-units-constant-k]').text('');
		$('[data-lohm-parameter-critical-temperature]').html('');
		$('[data-lohm-parameter-critical-pressure]').text('');
	}
});

// Standalone Calculator
// -- Control which input fields are shown
$('input[name^="lohm-solve-"]').change(function() {
	var id  = $(this).attr("id");
	var fluid_type = (/^lohm-liquid/.test(id)) ? 'liquid' : 'gas';
	debug__lohm_calculator('lohm solve id=',id,'fluid_type',fluid_type);
	var solve_for = $(`input[name='lohm-solve-${fluid_type}']:checked`).val();
	debug__lohm_calculator('solve for liquid lohm changed, solve_for',solve_for);
	
	set_form_options(fluid_type,solve_for);
})

// Standalone Calculators
$('.calculate-lohms-standalone').click(function(e){
	e.preventDefault();
	var fluid = $(this).data('fluid');
	execute_lohm_calculation(fluid);
});

var execute_lohm_calculation = async function(fluid) {
	debug__lohm_calculator('calculation type:',fluid);
	var form_id = `lohm_calculator_${fluid}`;	
	debug__lohm_calculator('calculation form_id:',form_id);
	
	// Get the lohm-liquid-solve or lohm-gas-solve to determine what to solve for.
	var solve_for = $(`input[name='lohm-solve-${fluid}']:checked`).val();

	debug__lohm_calculator('solve_for',solve_for);
		
	// This field is named lohm_fluid_type so that it doesn't conflict with the action
	// -- on the fluid_type field in the Product Finder Lohm Calculator
	var fluid_type = $(`#${form_id} select[name="lohm_fluid_type"]`).val();
	var temperature = parseFloat($(`#${form_id} input[name="temperature"]`).val());
	var temperature_unit = $(`#${form_id} select[name="temperature_unit"]`).val();
	var upstream_pressure = parseFloat($(`#${form_id} input[name="upstream_pressure"]`).val());
	var upstream_pressure_unit = $(`#${form_id} select[name="upstream_pressure_unit"]`).val();
	var downstream_pressure = parseFloat($(`#${form_id} input[name="downstream_pressure"]`).val());
	var downstream_pressure_unit = $(`#${form_id} select[name="downstream_pressure_unit"]`).val();
	var flow_rate = parseFloat($(`#${form_id} input[name="flow_rate"]`).val());
	var flow_rate_unit = $(`#${form_id} select[name="flow_rate_unit"]`).val();
	var lohms_user_value = $(`#${form_id} input[name="lohms_user_value"]`).val();
	var downstream_pressure_unit_selected;

	// Validate that all visible fields have valid data entered
	// -- Depending on liquid or gas and the solve_for option, different fields are displayed
	var validated = await valid_numeric_inputs(form_id);
	validated = (validated) ? validate_lohm_fields(form_id) : false;
	if (validated === false) {
		return false;
	}

	// product_type_id is to maintain consistency with the product finder calculator
	// -- Flow restrictors, product_type_id = 53 have an exception in the calculation of v_factor
	// -- This standalone calculator is independent of the product type 
	var product_type_id = null;	
	var pressure_unit, specific_gravity, viscosity, v_factor;

	if (fluid === 'liquid') {
		if (fluid_type === "other") {
			specific_gravity = parseFloat($(`#${form_id} input[name="specific_gravity"]`).val());
			viscosity = parseFloat($(`#${form_id} input[name="viscosity"]`).val());
		}
		v_factor = get_manual_v_factor(form_id);
		debug__lohm_calculator(`Entered v_factor: ${v_factor}`);
	} 
	
	// "Other" is only a fluid option for liquids, not gas
	
	debug__lohm_calculator(
		`Data entered by user before any pressure unit conversions
		solve_for ${solve_for}
		fluid_type ${fluid_type}
		temperature ${temperature}
		temperature_unit ${temperature_unit}
		upstream_pressure ${upstream_pressure}
		upstream_pressure_unit ${upstream_pressure_unit}
		downstream_pressure ${downstream_pressure}
		downstream_pressure_unit ${downstream_pressure_unit}
		flow_rate ${flow_rate}
		flow_rate_unit ${flow_rate_unit}
		lohms_user_value ${lohms_user_value}
		specific_gravity ${specific_gravity}
		viscosity ${viscosity}
		v_factor ${v_factor}`
	);

	// Gas - psig
	// -- must convert to psia because all gas reference data is in psia
	if (downstream_pressure_unit==='psig') {
		downstream_pressure = convert_psig_to_psia(downstream_pressure);
	}

	if (upstream_pressure_unit==='psig') {
		upstream_pressure = convert_psig_to_psia(upstream_pressure);
	}
	
	if (solve_for === 'pressure') {
		// Solving for pressure actually means solving for upstream pressure
		
		// Preserve the user's selected downstream pressure unit 
		// - when solving for pressure, the unit is converted.
		// - however, the units constant k **displayed** should be the value associated with the user's selection
		downstream_pressure_unit_selected = downstream_pressure_unit;

		// -- convert downstream_pressure to psi/psia if needed
		pressure_unit = (fluid==='liquid') ? 'psi' : 'psia';
		downstream_pressure = [pressure_unit, 'psig'].includes(downstream_pressure_unit) ? downstream_pressure : convert_to_psi(downstream_pressure, downstream_pressure_unit);		
	} else {
		// Make pressure units consistent
		// -- convert both to psi/psia if they differ
		if (upstream_pressure_unit !== downstream_pressure_unit) {
			pressure_unit = (fluid==='liquid') ? 'psi' : 'psia';
			// psig values already converted to psia above
			upstream_pressure = [pressure_unit, 'psig'].includes(upstream_pressure_unit) ? upstream_pressure : convert_to_psi(upstream_pressure, upstream_pressure_unit);
			downstream_pressure = [pressure_unit, 'psig'].includes(downstream_pressure_unit) ? downstream_pressure : convert_to_psi(downstream_pressure, downstream_pressure_unit);
			debug__lohm_calculator('updated upstream_pressure',upstream_pressure,'downstream_pressure',downstream_pressure,pressure_unit);
		} else {
			// psig values already converted to psia above
			pressure_unit = (upstream_pressure_unit==='psig') ? 'psia' : upstream_pressure_unit;
		}
		// Validate pressure here to ensure that the comparison is with the same pressure unit
		if (downstream_pressure >= upstream_pressure) {
			debug__lohm_calculator('downstream_pressure',downstream_pressure,'upstream_pressure',upstream_pressure);
			alert('Upstream Pressure must be greater than Downstream Pressure.');
			return false;
		} 
	}
	
	debug__lohm_calculator('pressure_unit = ',pressure_unit);
	
	var result = (fluid==='gas') ? 
		calculate_gas_lohm_rate(
			fluid_type,
			upstream_pressure,
			downstream_pressure,
			flow_rate,
			pressure_unit,
			flow_rate_unit,
			temperature,
			temperature_unit,
			solve_for,
			lohms_user_value
		)  : 
		calculate_liguid_lohm_rate(
			fluid_type,
			upstream_pressure,
			downstream_pressure,
			flow_rate,
			product_type_id,
			pressure_unit,
			flow_rate_unit,
			temperature,
			temperature_unit,
			solve_for,
			specific_gravity,
			viscosity,
			lohms_user_value,
			v_factor
		);
			
	debug__lohm_calculator('****Calculated result',result);
	
	if (result===false) {
		debug__lohm_calculator('result is false due to parameters outside valid limits');
		return false
	}
	
	// For all results, round to 3 significant digits (toPrecision)
	// -- then convert from scientific notation (toFixed)
	switch (solve_for) {
		case 'pressure':			
			upstream_pressure = result.upstream_pressure;
						
			// if downstream_pressure_unit differs from pressure_unit
			// -- convert upstream_pressure to the  downstream_pressure_unit
			debug__lohm_calculator(`***Calculating pressure downstream_pressure_unit: ${downstream_pressure_unit}result.upstream_pressure: ${upstream_pressure}`);
			upstream_pressure = (downstream_pressure_unit !== pressure_unit) ? 
				convert_from_psi(upstream_pressure,downstream_pressure_unit) : upstream_pressure;
			// Show 3 significant digits and show full number instead of exponential notation
			upstream_pressure = parseFloat(upstream_pressure.toPrecision(3));
			debug__lohm_calculator('****Calculated upstream_pressure to 3 significant digits',upstream_pressure);
			// Show all pressure units without a conversion to uppercase
			// -- kPa to KPA is especially wrong, so use the units as they are in the select
			$(`#lohms_${fluid}`).text(`${upstream_pressure} ${downstream_pressure_unit}`);
			break;
		case 'flow-rate':
			debug__lohm_calculator('returned value of flow_rate',result.flow_rate);
			//flow_rate = Number(result.flow_rate).toPrecision(3) ;
			// Show 3 significant digits and show full number instead of exponential notation
			flow_rate = parseFloat(result.flow_rate.toPrecision(3));
			// in3/min should properly be shown as in(cubed)/min
			var display_flow_rate_unit = (flow_rate_unit==='in3/min') ? 'in&#179;/min' : flow_rate_unit;
			debug__lohm_calculator('****Calculated flow_rate to 3 significant digits',flow_rate);
			$(`#lohms_${fluid}`).html(`${flow_rate} ${display_flow_rate_unit}`);
			break;
		default:
			// lohms
			var lohms = parseFloat(Number(result.lohms).toPrecision(3)).toFixed();
			debug__lohm_calculator('****Calculated lohms to 3 significant digits:',lohms,'full result:',result.lohms);
			$(`#lohms_${fluid}`).text(`${lohms} Lohms`);
	}

	// Display additional calculations
	if (fluid === 'liquid') {
		
		specific_gravity = (specific_gravity) ? specific_gravity : result.specific_gravity.toFixed(3);
		viscosity = (viscosity) ? viscosity : result.viscosity.toFixed(3);
		v_factor = +result.v_factor.toFixed(3);
				
		// Always display V-factor
		$('[data-lohm-parameter-v-factor]').text(v_factor);
		if (fluid_type !== 'other') {
			debug__lohm_calculator('displaying specific gravity and viscosity');
			$('[data-lohm-parameter-specific-gravity]').text(specific_gravity);	
			$('[data-lohm-parameter-viscosity]').text(viscosity);
		}
		
	} else {
		// Display units_constant_k from calculation
		// -- except for gassess: show units_constant_k from user selected
		// When solving for pressure, if downstream pressure unit selected is psig, switch to psia to get constant k
		downstream_pressure_unit_selected = (downstream_pressure_unit_selected==='psig') ? 'psia' : downstream_pressure_unit_selected;
		debug__lohm_calculator(`fluid_type: ${fluid_type} 
			downstream_pressure_unit_selected: ${downstream_pressure_unit_selected} flow_rate_unit: ${flow_rate_unit}`);	
		var units_constant_k = (solve_for==='pressure') ? 
			gas_units_k[fluid_type][downstream_pressure_unit_selected][flow_rate_unit] : result.units_constant_k;
		var critical_pressure = gas_units_k[fluid_type]['critical_pressure'];
		var critical_temperature = gas_units_k[fluid_type]['critical_temperature'];
		$('[data-lohm-parameter-units-constant-k]').text(+units_constant_k.toPrecision(3));
		$('[data-lohm-parameter-critical-temperature]').html(`${critical_temperature} &deg;F`);
		$('[data-lohm-parameter-critical-pressure]').text(`${critical_pressure} psia`);
	}
};

var validate_lohm_fields = function (form_id) {
	var validated = true;
	debug__lohm_calculator('validate_lohm_fields');	
	// Validate against temperature limits
	var fluid_type = $(`#${form_id} select[name='lohm_fluid_type']`).val();
	var temperature = parseFloat($(`#${form_id} input[name='temperature']`).val());
	var temperature_unit = $(`#${form_id} select[name='temperature_unit']`).val();
	var fluid_type_display = $(`#${form_id} select[name='lohm_fluid_type'] option:selected`).text();
	debug__lohm_calculator(`validate_lohm_fields fluid_type: ${fluid_type} temperature: ${temperature} temperature_unit: ${temperature_unit}`);
	validated = validate_temp_limits(temperature,temperature_unit,fluid_type,fluid_type_display);
	return validated;
}

var valid_numeric_inputs = function(form_id) {
	return new Promise((resolve,reject)=>{
		// Validate that all visible numeric fields have a value entered
		var validated = true;
		var missing_fields = [];
		
		$(`#${form_id} input[type=number]`).each(function() {
			var field_name = $(this).attr('name');
			var value = $(this).val();
			var is_visible = $(this).is(":visible");
			// Clear non-numerics
			if (value && is_visible) {
				value = validate_numeric_input_characters(value);
			}
			$(this).val(value);
			if ( $(this).is(":visible") && value == '') {
				var display_field = (field_name==='lohms_user_value') ? 'Lohms' : field_name.replace('_',' ').toLowerCase()
					.split(' ')
					.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
					.join(' ');
				validated = false;
				missing_fields.push(display_field);
			}
	 	});
	 	if (missing_fields.length > 0) {
			// Assemble missing fields into readable text for alert;
			var fields_list = missing_fields.toString().replace(/,([^,]*)$/, ' and $1').replace(/,/g,', ');
	 		alert(`Please enter ${fields_list}`);
	 	}
	 	resolve(validated);
 	});
}

var validate_temp_limits = function(temperature,temperature_unit,fluid_type,fluid_type_display) {	
	// temp_limits[fluid_type] should be defined for all fluids
	// -- An error message to the user does not provide a service
	// -- if limits for a fluid are not defined. The user can not take an action to correct this.
	// -- The better option is to let the calculation proceed.
	if (temp_limits[fluid_type]) {
		var upper_temp = temp_limits[fluid_type][`upper${temperature_unit}`];
		var lower_temp = temp_limits[fluid_type][`lower${temperature_unit}`];
		debug__lohm_calculator(`validate_temp_limits upper_temp: ${upper_temp} lower_temp: ${lower_temp} `);
		if (temperature < lower_temp ||  temperature > upper_temp) {
			alert(`Temperatures for ${fluid_type_display} must be between ${lower_temp}° ${temperature_unit} and ${upper_temp}° ${temperature_unit}`);
			return false;
		}
	} else {
		debug__lohm_calculator(`validate_temp_limits no temp limit entries for ${fluid_type}`);
	}
	
	return true;
	
}

$("#lohm-liquid :input[type='number']").keyup(function(e) {
	validate_negative_input($(this));	
});

$("#lohm-gas :input[type='number']").keyup(function(e) {
	validate_negative_input($(this));	
});

var validate_negative_input = function(element) {
	var value = $(element).val();		
	var field_name = $(element).attr("name");
	if (field_name !== "temperature" && value < 0) {
		 value = value * -1;
		 $(element).val(value);
	}
}

var validate_numeric_input_characters = function(value) {
	debug__lohm_calculator(`validate_numeric_input_characters value: ${value}`);
	// if non-numeric or character other than minus has been entered
	// - clear value 
	if (value.match(/[^\d.-]/)) {
		return '';
	} else {
		value = (value=="-0") ? "0" : value;
		value = (value && value !== "0") ? value.replace(/^[0]+/g,"") : value ;
		debug__lohm_calculator(`Step 2 value: ${value}`);
		value = (value) ? value.replace(/^-[0]+/g,"-") : value ;
		debug__lohm_calculator(`Step 3 value: ${value}`);
		return value;
	}
}

var set_form_options = function(fluid_type,solve_for) {
	// flow-rate is always shown
	$(`fieldset.lohm-${fluid_type}-flow-rate`).show();
	
	// When flow-rate is selected:
	// -- hide the entry value 
	// -- expand the dropdown to the entire row
	if (solve_for === 'flow-rate') {
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-value`).hide();
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).removeClass('col-5');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).removeClass('col-lg-6');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).removeClass('ps-1');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).addClass('col-12');
	} else {
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-value`).show();
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).removeClass('col-12');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).addClass('col-5');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).addClass('col-lg-6');
		$(`fieldset.lohm-${fluid_type}-flow-rate .flow-rate-unit`).addClass('ps-1');
	}

	switch (solve_for) {
		case 'pressure':
			debug__lohm_calculator('solve for upstream pressure');
			$(`fieldset.lohm-${fluid_type}-pressure`).hide();
			$(`fieldset.lohm-${fluid_type}-lohms`).removeClass('hidden');
			$(`fieldset.lohm-${fluid_type}-lohms`).show();
			break;
		case 'flow-rate':
			debug__lohm_calculator('solve for flow-rate');
			// Close flow rate entry field
			// Expand the dropdown to the full width
			$(`fieldset.lohm-${fluid_type}-pressure`).show();
			$(`fieldset.lohm-${fluid_type}-lohms`).removeClass('hidden');
			$(`fieldset.lohm-${fluid_type}-lohms`).show();
			break;
		default:
			debug__lohm_calculator('solve for lohms');
			$(`fieldset.lohm-${fluid_type}-pressure`).show();
			$(`fieldset.lohm-${fluid_type}-lohms`).hide();
	}

	// Clear out display only results
	$(`#lohms_${fluid_type}`).text('');
	
	if (fluid_type==='liquid') {
		$('[data-lohm-parameter-specific-gravity]').text('');	
		$('[data-lohm-parameter-viscosity]').text('');
		$('[data-lohm-parameter-v-factor]').text('');
	} else {
		$('[data-lohm-parameter-units-constant-k]').text('');
		$('[data-lohm-parameter-critical-temperature]').html('');
		$('[data-lohm-parameter-critical-pressure]').text('');
	}

}

// Manually entered v-factor
$('input[name="manual-enter-v-factor"]').click(function(){
	// Entered an calculated values of v_factor are **intentionally** not being cleared
	// -- Keeping the values provides a more useful display.
	// -- The user will not have to keep re-entered a v_factor if making with multiple calculations
	if($(this).prop("checked") == true){
		// show input field for v_factor
		// hide display for v_factor
		$('[data-lohm-parameter-v-factor]').hide();	
		$('input[name="v_factor"]').removeClass('hidden');
	} else {
		// show display for v_factor
		// hide and clear input fields for v_factor
		$('input[name="v_factor"]').addClass('hidden');
		$('[data-lohm-parameter-v-factor]').show();	
	}
});

var get_manual_v_factor = function(form_id) {
	// If manually enter V Factor is checked, return the V Factor value
	var is_checked = $('input[name="manual-enter-v-factor"]').prop("checked");
	var v_factor = (is_checked) ? parseFloat($(`#${form_id} input[name="v_factor"]`).val()) : null;
	return v_factor;
}

// Convert PSIA to selected unit
// -- upstream pressure is psia.
// -- convert to psig, bar, kPa, mm Hg or kg/sq. cm
var convert_from_psi = function (upstream_pressure,downstream_pressure_unit) {
	debug__lohm_calculator(`convert_from_psi upstream_pressure: ${upstream_pressure} 
		downstream_pressure_unit: ${downstream_pressure_unit}`)

	switch (downstream_pressure_unit.toLowerCase())	{
		case 'bar':
			upstream_pressure = upstream_pressure / 14.503773773;
			break;
		case 'kpa':
			upstream_pressure = upstream_pressure * 6.895;
			break;
		case 'psig':
			upstream_pressure = upstream_pressure - 14.696704;
			break;
		case 'mm hg':
			upstream_pressure = upstream_pressure * 51.7149;
			break;
		case 'kg/sq. cm':
			upstream_pressure = upstream_pressure * 0.070306958;
		break;
	}
	debug__lohm_calculator(`convert_from_psi converted upstream_pressure: ${upstream_pressure}`);
	return upstream_pressure;
	
}

/*

	Reference values needed for calculations

*/
// For liquids, get UNIT K constant from flow rate unit vs pressure
var liquid_units_k = {
"gpm" : {
		"type": "volumetric", "psi": 20, "bar": 76.2, "kPa": 7.62, "mm Hg": 2.781, "kg/sq. cm": 75.43
	}, 
"L/min" : {
		"type": "volumetric", "psi": 75.7, "bar": 288, "kPa": 28.8, "mm Hg": 10.53, "kg/sq. cm": 285.5
	}, 
"mL/min" : {
		"type": "volumetric", "psi": 75700, "bar": 288000, "kPa": 28800, "mm Hg": 10527, "kg/sq. cm": 285494
	}, 
"in3/min" : {
		"type": "volumetric", "psi": 4620, "bar": 17600, "kPa": 1760, "mm Hg": 642.4, "kg/sq. cm": 17424
	}, 
"PPH" : {
		"type": "gravimetric", "psi": 10000, "bar": 38100, "kPa": 3810, "mm Hg": 1391, "kg/sq. cm": 37714
	}, 
"gm/min" : {
		"type": "gravimetric", "psi": 75700, "bar": 288000, "kPa": 28800, "mm Hg": 10527, "kg/sq. cm": 285494
	}
};

var gas_flow_units = {
	"volumetric": ['SLPM','SCFM','in3/min','SLPM','SCFM','SLPM','mL/min'],
	"gravimetric": ['PPH','lbm/s','kg/min','PPH','kg/min','kg/min','gm/min']
};

// Mike from Lee supplied a spreadsheet with these calculated values
// -- The values match the rounded versions above from the THH Handbook (O32-O33)
// -- IMPORTANT: psi are the psia values
// -- critical_temperature and critical_pressure are from a table in the VB source code
var gas_units_k = {
"hydrogen": {
	"type":"gas",
	"critical_temperature": "-400",
	"critical_pressure": "188",
	"psia": {
		"SLPM":1030, "SCFM":36.3, "in3/min": 62700, "mL/min": 1030000, "PPH": 11.6, "lbm/s": 0.00322, "kg/min": 0.0876, "gm/min": 87.69453067
	},
	"bar": {
		"SLPM":14900, "SCFM":526, "in3/min": 911626.9399, "mL/min": 14938887.62, "PPH": 168, "lbm/s": 0.046734384, "kg/min": 1.27, "gm/min": 1271.901688
	},
	"kPa": {
		"SLPM":149, "SCFM":5.275618865, "in3/min": 9116.269399, "mL/min": 149388.8762, "PPH": 1.682437829, "lbm/s": 0.000467344, "kg/min": 0.0127, "gm/min": 12.71901688
	},
	"mm Hg": {
		"SLPM":19.91687894, "SCFM":0.703358007, "in3/min": 1215.402636, "mL/min": 19900, "PPH": 0.224306598, "lbm/s": 6.23E-05, "kg/min": 0.001695729, "gm/min": 1.69
	}
},
"helium": {
	"type":"gas",
	"critical_temperature": "-450",
	"critical_pressure": "33",
	"psia": {
		"SLPM":771, "SCFM":27.2, "in3/min": 47100, "mL/min": 771000, "PPH": 17.3, "lbm/s": 0.00479, "kg/min": 0.131, "gm/min": 130.7858087
	},
	"bar": {
		"SLPM":11200, "SCFM":395, "in3/min": 682392.5929, "mL/min": 11182410.05, "PPH": 250, "lbm/s": 0.069698694, "kg/min": 1.89, "gm/min": 1896.887862
	},
	"kPa": {
		"SLPM":112, "SCFM":3.949031209, "in3/min": 6823.925929, "mL/min": 111824.1005, "PPH": 2.509152969, "lbm/s": 0.000696987, "kg/min": 0.0189, "gm/min": 18.96887862
	},
	"mm Hg": {
		"SLPM":14.90865404, "SCFM":0.526494198, "in3/min": 909.7819733, "mL/min": 14900, "PPH": 0.334526219, "lbm/s": 9.29E-05, "kg/min": 0.002528976, "gm/min": 2.52
	}
},
"neon": {
	"type":"gas",
	"critical_temperature": "-380",
	"critical_pressure": "389",
	"psia": {
		"SLPM":343, "SCFM":12.1, "in3/min": 20900, "mL/min": 343000, "PPH": 38.7, "lbm/s": 0.0108, "kg/min": 0.293, "gm/min": 292.567098
	},
	"bar": {
		"SLPM":4980, "SCFM":176, "in3/min": 303580.6217, "mL/min": 4974794.616, "PPH": 561, "lbm/s": 0.155915575, "kg/min": 4.25, "gm/min": 4243.327183
	},
	"kPa": {
		"SLPM":49.8, "SCFM":1.756832302, "in3/min": 3035.806217, "mL/min": 49747.94616, "PPH": 5.612960689, "lbm/s": 0.001559156, "kg/min": 0.0425, "gm/min": 42.43327183
	},
	"mm Hg": {
		"SLPM":6.632514053, "SCFM":0.234225045, "in3/min": 404.7408779, "mL/min": 6640, "PPH": 0.748333218, "lbm/s": 0.00020787, "kg/min": 0.005657304, "gm/min": 5.66
	}
},
"natgas": {
	"type":"gas",
	"critical_temperature": "-80",
	"critical_pressure": "670",
	"psia": {
		"SLPM":319, "SCFM":11.3, "in3/min": 19400, "mL/min": 319000, "PPH": 34.8, "lbm/s": 0.00966, "kg/min": 0.263, "gm/min": 263.083592
	},
	"bar": {
		"SLPM":4620, "SCFM":163, "in3/min": 282338.829, "mL/min": 4626704.03, "PPH": 505, "lbm/s": 0.140203152, "kg/min": 3.82, "gm/min": 3815.705064
	},
	"kPa": {
		"SLPM":46.2, "SCFM":1.63390526, "in3/min": 2823.38829, "mL/min": 46267.0403, "PPH": 5.047313488, "lbm/s": 0.001402032, "kg/min": 0.0382, "gm/min": 38.15705064
	},
	"mm Hg": {
		"SLPM":6.168431437, "SCFM":0.217836121, "in3/min": 376.4208165, "mL/min": 6160, "PPH": 0.672919793, "lbm/s": 0.000186922, "kg/min": 0.005087188, "gm/min": 5.09
	}
},
"nitrogen": {
	"type":"gas",
	"critical_temperature": "-232",
	"critical_pressure": "492",
	"psia": {
		"SLPM":276, "SCFM":9.73, "in3/min": 16800, "mL/min": 276000, "PPH": 43.2, "lbm/s": 0.012, "kg/min": 0.326, "gm/min": 326.586528
	},
	"bar": {
		"SLPM":4000, "SCFM":141, "in3/min": 244280.6169, "mL/min": 4003041.732, "PPH": 626, "lbm/s": 0.174045293, "kg/min": 4.73, "gm/min": 4736.737321
	},
	"kPa": {
		"SLPM":40, "SCFM":1.413660977, "in3/min": 2442.806169, "mL/min": 40030.41732, "PPH": 6.265630536, "lbm/s": 0.001740453, "kg/min": 0.0473, "gm/min": 47.36737321
	},
	"mm Hg": {
		"SLPM":5.336950084, "SCFM":0.188472631, "in3/min": 325.6807064, "mL/min": 5330, "PPH": 0.835348709, "lbm/s": 0.000232041, "kg/min": 0.00631513, "gm/min": 6.31
	}
},
"carbon_monoxide": {
	"type":"gas",
	"critical_temperature": "-218",
	"critical_pressure": "514",
	"psia": {
		"SLPM":274, "SCFM":9.69, "in3/min": 16700, "mL/min": 274000, "PPH": 43, "lbm/s": 0.0119, "kg/min": 0.325, "gm/min": 325.0745533
	},
	"bar": {
		"SLPM":3980, "SCFM":141, "in3/min": 242510.4675, "mL/min": 3974034.183, "PPH": 623, "lbm/s": 0.173239527, "kg/min": 4.71, "gm/min": 4714.807981
	},
	"kPa": {
		"SLPM":39.8, "SCFM":1.403417057, "in3/min": 2425.104675, "mL/min": 39740.34183, "PPH": 6.236622988, "lbm/s": 0.001732395, "kg/min": 0.0471, "gm/min": 47.14807981
	},
	"mm Hg": {
		"SLPM":5.298276533, "SCFM":0.187106887, "in3/min": 323.3207013, "mL/min": 5300, "PPH": 0.831481354, "lbm/s": 0.000230967, "kg/min": 0.006285894, "gm/min": 6.28
	}
},
"air": {
	"type":"gas",
	"critical_temperature": "-221",
	"critical_pressure": "546",
	"psia": {
		"SLPM":271, "SCFM":9.56, "in3/min": 16500, "mL/min": 271000, "PPH": 43.8, "lbm/s": 0.0122, "kg/min": 0.331, "gm/min": 331.122452
	},
	"bar": {
		"SLPM":3930, "SCFM":139, "in3/min": 239855.2434, "mL/min": 3930522.86, "PPH": 636, "lbm/s": 0.176462588, "kg/min": 4.81, "gm/min": 4802.525339
	},
	"kPa": {
		"SLPM":39.3, "SCFM":1.388051177, "in3/min": 2398.552434, "mL/min": 39305.2286, "PPH": 6.352653183, "lbm/s": 0.001764626, "kg/min": 0.0481, "gm/min": 48.02525339
	},
	"mm Hg": {
		"SLPM":5.240266206, "SCFM":0.185058272, "in3/min": 319.7806936, "mL/min": 5230, "PPH": 0.846950774, "lbm/s": 0.000235264, "kg/min": 0.006402841, "gm/min": 6.41
	}
},
"ethane": {
	"type":"gas",
	"critical_temperature": "90",
	"critical_pressure": "717",
	"psia": {
		"SLPM":251, "SCFM":8.86, "in3/min": 15300, "mL/min": 251000, "PPH": 42.2, "lbm/s": 0.0117, "kg/min": 0.319, "gm/min": 319.0266547
	},
	"bar": {
		"SLPM":3640, "SCFM":129, "in3/min": 222153.7494, "mL/min": 3640447.372, "PPH": 611, "lbm/s": 0.170016466, "kg/min": 4.62, "gm/min": 4627.090624
	},
	"kPa": {
		"SLPM":36.4, "SCFM":1.285611976, "in3/min": 2221.537494, "mL/min": 36404.47372, "PPH": 6.120592792, "lbm/s": 0.001700165, "kg/min": 0.0462, "gm/min": 46.27090624
	},
	"mm Hg": {
		"SLPM":4.853530692, "SCFM":0.171400835, "in3/min": 296.1806424, "mL/min": 4850, "PPH": 0.816011933, "lbm/s": 0.00022667, "kg/min": 0.006168947, "gm/min": 6.16
	}
},
"oxygen": {
	"type":"gas",
	"critical_temperature": "-182",
	"critical_pressure": "730",
	"psia": {
		"SLPM":257, "SCFM":9.08, "in3/min": 15700, "mL/min": 257000, "PPH": 46, "lbm/s": 0.0128, "kg/min": 0.348, "gm/min": 347.7541733
	},
	"bar": {
		"SLPM":3730, "SCFM":132, "in3/min": 227464.1976, "mL/min": 3727470.018, "PPH": 667, "lbm/s": 0.185326006, "kg/min": 5.04, "gm/min": 5043.748073
	},
	"kPa": {
		"SLPM":37.3, "SCFM":1.316343736, "in3/min": 2274.641976, "mL/min": 37274.70018, "PPH": 6.671736219, "lbm/s": 0.00185326, "kg/min": 0.0504, "gm/min": 50.43748073
	},
	"mm Hg": {
		"SLPM":4.969551346, "SCFM":0.175498066, "in3/min": 303.2606578, "mL/min": 4970, "PPH": 0.889491681, "lbm/s": 0.000247081, "kg/min": 0.006724444, "gm/min": 6.72
	}
},
"argon": {
	"type":"gas",
	"critical_temperature": "-187",
	"critical_pressure": "705",
	"psia": {
		"SLPM":245, "SCFM":8.65, "in3/min": 14900, "mL/min": 245000, "PPH": 54.6, "lbm/s": 0.0152, "kg/min": 0.413, "gm/min": 412.769084
	},
	"bar": {
		"SLPM":3550, "SCFM":125, "in3/min": 216843.3012, "mL/min": 3553424.725, "PPH": 792, "lbm/s": 0.219973912, "kg/min": 5.99, "gm/min": 5986.709669
	},
	"kPa": {
		"SLPM":35.5, "SCFM":1.254880216, "in3/min": 2168.433012, "mL/min": 35534.24725, "PPH": 7.919060817, "lbm/s": 0.002199739, "kg/min": 0.0599, "gm/min": 59.86709669
	},
	"mm Hg": {
		"SLPM":4.737510038, "SCFM":0.167303604, "in3/min": 289.1006271, "mL/min": 4730, "PPH": 1.055787951, "lbm/s": 0.000293274, "kg/min": 0.007981623, "gm/min": 7.99
	}
},
"carbon_dioxide": {
	"type":"gas",
	"critical_temperature": "88",
	"critical_pressure": "1072",
	"psia": {
		"SLPM":213, "SCFM":7.52, "in3/min": 13000, "mL/min": 213000, "PPH": 52.4, "lbm/s": 0.0145, "kg/min": 0.396, "gm/min": 396.1373627
	},
	"bar": {
		"SLPM":3090, "SCFM":109, "in3/min": 188520.9109, "mL/min": 3089303.945, "PPH": 759, "lbm/s": 0.211110494, "kg/min": 5.74, "gm/min": 5745.486935
	},
	"kPa": {
		"SLPM":30.9, "SCFM":1.090977493, "in3/min": 1885.209109, "mL/min": 30893.03945, "PPH": 7.59997778, "lbm/s": 0.002111105, "kg/min": 0.0574, "gm/min": 57.45486935
	},
	"mm Hg": {
		"SLPM":4.118733217, "SCFM":0.145451704, "in3/min": 251.3405452, "mL/min": 4110, "PPH": 1.013247045, "lbm/s": 0.000281458, "kg/min": 0.007660019, "gm/min": 7.65
	}
},

"nitrous_oxide": {
	"type":"gas",
	"critical_temperature": "88",
	"critical_pressure": "1072",
	"psia": {
		"SLPM":214, "SCFM":7.56, "in3/min": 13100, "mL/min": 214000, "PPH": 52.7, "lbm/s": 0.0146, "kg/min": 0.398, "gm/min": 398.4053247
	},
	"bar": {
		"SLPM":3100, "SCFM":110, "in3/min": 189405.9856, "mL/min": 3103807.719, "PPH": 764, "lbm/s": 0.212319142, "kg/min": 5.77, "gm/min": 5778.380945
	},
	"kPa": {
		"SLPM":31, "SCFM":1.096099454, "in3/min": 1894.059856, "mL/min": 31038.07719, "PPH": 7.643489103, "lbm/s": 0.002123191, "kg/min": 0.0577, "gm/min": 57.78380945
	},
	"mm Hg": {
		"SLPM":4.138069993, "SCFM":0.146134576, "in3/min": 252.5205477, "mL/min": 4140, "PPH": 1.019048078, "lbm/s": 0.000283069, "kg/min": 0.007703874, "gm/min": 7.7
	}
},
"sulfur_dioxide": {
	"type":"gas",
	"critical_temperature": "315",
	"critical_pressure": "1141",
	"psia": {
		"SLPM":176, "SCFM":6.21, "in3/min": 10700, "mL/min": 176000, "PPH": 63, "lbm/s": 0.0175, "kg/min": 0.476, "gm/min": 476.27202
	},
	"bar": {
		"SLPM":2550, "SCFM":90.1, "in3/min": 155773.147, "mL/min": 2552664.293, "PPH": 914, "lbm/s": 0.253816052, "kg/min": 6.91, "gm/min": 6907.741926
	},
	"kPa": {
		"SLPM":25.5, "SCFM":0.901464971, "in3/min": 1557.73147, "mL/min": 25526.64293, "PPH": 9.137377866, "lbm/s": 0.002538161, "kg/min": 0.0691, "gm/min": 69.07741926
	},
	"mm Hg": {
		"SLPM":3.403272517, "SCFM":0.120185446, "in3/min": 207.6804505, "mL/min": 3400, "PPH": 1.218216867, "lbm/s": 0.000338394, "kg/min": 0.009209565, "gm/min": 9.21
	}
},
"freon": {
	"type":"gas",
	"critical_temperature": "233",
	"critical_pressure": "580",
	"psia": {
		"SLPM":123, "SCFM":4.34, "in3/min": 7510, "mL/min": 123000, "PPH": 83.2, "lbm/s": 0.0231, "kg/min": 0.629, "gm/min": 628.9814613
	},
	"bar": {
		"SLPM":1780, "SCFM":63, "in3/min": 108864.188, "mL/min": 1783964.25, "PPH": 1210, "lbm/s": 0.335198341, "kg/min": 9.12, "gm/min": 9122.605211
	},
	"kPa": {
		"SLPM":17.8, "SCFM":0.630001088, "in3/min": 1088.64188, "mL/min": 17839.6425, "PPH": 12.06714029, "lbm/s": 0.003351983, "kg/min": 0.0912, "gm/min": 91.22605211
	},
	"mm Hg": {
		"SLPM":2.378423407, "SCFM":0.083993238, "in3/min": 145.1403148, "mL/min": 2380, "PPH": 1.608819735, "lbm/s": 0.000446894, "kg/min": 0.012162473, "gm/min": 12.2
	}
},
"xenon": {
	"type":"gas",
	"critical_temperature": "62",
	"critical_pressure": "847",
	"psia": {
		"SLPM":135, "SCFM":4.77, "in3/min": 8235, "mL/min": 135000, "PPH": 97.6, "lbm/s": 0.0271, "kg/min": 0.738, "gm/min": 737.8436373
	},
	"bar": {
		"SLPM":1956, "SCFM":69.1, "in3/min": 119485.0844, "mL/min": 1958009.543, "PPH": 1415.6, "lbm/s": 0.393213439, "kg/min": 10.7, "gm/min": 10701.51765
	},
	"kPa": {
		"SLPM":19.6, "SCFM":0.691464609, "in3/min": 1194.850844, "mL/min": 19580.09543, "PPH": 14.1556838, "lbm/s": 0.003932134, "kg/min": 0.107, "gm/min": 107.0151765
	},
	"mm Hg": {
		"SLPM":2.610464715, "SCFM":0.0921877, "in3/min": 159.3003455, "mL/min": 2605, "PPH": 1.887269305, "lbm/s": 0.000524241, "kg/min": 0.014267517, "gm/min": 14.24
	}
}
};   

var temp_limits = {
	"#2 Diesel Oil": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"CTFE AO-2 (devel)": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"Isopropyl Alcohol": {"lowerF":-80, "upperF":180, "lowerC":-62, "upperC":82},
	"MIL-PRF-7024": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-5606": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-83282": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-23699": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-7808": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-5624 (JP-4)": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"MIL-PRF-5624 (JP-5)": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"SAE 10 Oil": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"Silicone (200 cS)": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"Skydrol 500B-4": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"Skydrol LD-4": {"lowerF":-65, "upperF":400, "lowerC":-54, "upperC":204},
	"Transaqua HT": {"lowerF":-22, "upperF":356, "lowerC":-30, "upperC":180},
	"Water": {"lowerF":32, "upperF":212, "lowerC":0, "upperC":204},	
	"air": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"argon": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"carbon_dioxide": {"lowerF":-100, "upperF":400, "lowerC":-73, "upperC":204},
	"carbon_monoxide": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"ethane": {"lowerF":-100, "upperF":400, "lowerC":-73, "upperC":204},
	"freon": {"lowerF":0, "upperF":400, "lowerC":-17.78, "upperC":204},
	"helium": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"hydrogen": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"natgas": {"lowerF":-100, "upperF":400, "lowerC":-73, "upperC":204},
	"neon": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"nitrogen": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"nitrous_oxide": {"lowerF":-100, "upperF":400, "lowerC":-73, "upperC":204},
	"oxygen": {"lowerF":-300, "upperF":400, "lowerC":-184, "upperC":204},
	"sulfur_dioxide": {"lowerF":0, "upperF":400, "lowerC":-17.78, "upperC":204},
	"xenon": {"lowerF":-165, "upperF":400, "lowerC":-109, "upperC":204}		
}

// Values for calculating specific gravity
// -- Based on LEE details and feedback
var liquids_for_SG = {
"CTFE AO-2 (devel)":{
	"SGMFunc": 0.363, "SGBFunc": 16.73, "VISCMFunc": 0.963, "VISCBFunc": 8.95, "LiqTUL": 400, "LiqTLL": -65
},
"#2 Diesel Oil":{
	"SGMFunc": 0.208, "SGBFunc": 4.24, "VISCMFunc": 0.786, "VISCBFunc": 7.75, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-7024":{
	"SGMFunc": 0.1577, "SGBFunc": 2.64, "VISCMFunc": 0.766, "VISCBFunc": 5.58, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-5606":{
	"SGMFunc": 0.1552, "SGBFunc": 3.65, "VISCMFunc": 0.496, "VISCBFunc": 8.59, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-83282":{
	"SGMFunc": 0.1552, "SGBFunc": 3.65, "VISCMFunc": 0.679, "VISCBFunc": 9.53, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-7808":{
	"SGMFunc": 0.156, "SGBFunc": 4.52, "VISCMFunc": 0.679, "VISCBFunc": 9.53, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-23699":{
	"SGMFunc": 0.1797, "SGBFunc": 5.43, "VISCMFunc": 0.698, "VISCBFunc": 10.18, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-5624 (JP-4)":{
	"SGMFunc": 0.1501, "SGBFunc": 2.83, "VISCMFunc": 0.792, "VISCBFunc": 5.36, "LiqTUL": 400, "LiqTLL": -65
},
"MIL-PRF-5624 (JP-5)":{
	"SGMFunc": 0.1292, "SGBFunc": 3.41, "VISCMFunc": 0.795, "VISCBFunc": 6.95, "LiqTUL": 400, "LiqTLL": -65
},
"SAE 10 Oil":{
	"SGMFunc": 0.208, "SGBFunc": 4.24, "VISCMFunc": 0.745, "VISCBFunc": 10.6, "LiqTUL": 400, "LiqTLL": -65
},
"Silicone (200 cS)":{
	"SGMFunc": 0.1817, "SGBFunc": 5.2, "VISCMFunc": 0.222, "VISCBFunc": 8.7, "LiqTUL": 400, "LiqTLL": -65
},
"Skydrol LD-4":{
	"SGMFunc": 0.273, "SGBFunc": 5.75, "VISCMFunc": 0.565, "VISCBFunc": 8.72, "LiqTUL": 400, "LiqTLL": -65
},
"Skydrol 500B-4":{
	"SGMFunc": 0.1751, "SGBFunc": 6.27, "VISCMFunc": 0.565, "VISCBFunc": 8.72, "LiqTUL": 400, "LiqTLL": -65
},
"Water":{
	"SGMFunc": 0.0446, "SGBFunc": 4.99, "VISCMFunc": 1.355, "VISCBFunc": 7.71, "LiqTUL": 400, "LiqTLL": 32
},
"Isopropyl Alcohol":{
	"SGMFunc": 1, "SGBFunc": 0, "VISCMFunc": 1, "VISCBFunc": 0, "LiqTUL": 180, "LiqTLL": -80
},
"Transaqua HT":{
	"SGMFunc": 1, "SGBFunc": 0, "VISCMFunc": 1, "VISCBFunc": 0, "LiqTUL": 356, "LiqTLL": -22
}
};

// Use in calculating V_Factor for single orifice restrictors
var DCur = {
1: {
	1: 6.6802,
	2: -0.97476,
	3: -0.025775,
	4: 0.011544,
	5: -0.0020641,
	6: 0.0001262,
},
2: {
	// for 1 - 6 psi
	1: 6.6798,
	2: -0.44405,
	3: -0.014964,
	4: -0.01867,
	5: 0.0032405,
	6: -0.00015647,
},
3: {
	// for 6 - 25 psi
	1: 6.6806,
	2: 0.00483,
	3: -0.068629,
	4: 0.017883,
	5: -0.0028777,
	6: 0.00011789,
},
4: {
	// for 25-100 psi
	1: 6.6733,
	2: 0.10842,
	3: -0.102215,
	4: 0.025495,
	5: -0.0030102,
	6: 0.00009526,
},
5: {
	// for 100-400 psi
	1: 6.6803,
	2: -0.03021,
	3: 0.038716,
	4: -0.013942,
	5: 0.0016841,
	6: -0.00008899,
},
6: {
	// for 400-1000 psi
	1: 6.6812,
	2: -0.02773,
	3: 0.03081,
	4: -0.010607,
	5: 0.0013744,
	6: -0.00007451,
},
7: {
	// for 1000-3000 psi
	1: 6.6796,
	2: 0.00946,
	3: -0.011159,
	4: 0.004276,
	5: -0.0005999,
	6: 0.00002057,
},
8: {
	// for 3000-10000 psi
	1: 6.6799,
	2: -0.00104,
	3: 0.002643,
	4: -0.00158,
	5: 0.0003366,
	6: -0.00002338,
},
9: {
	// for 3000-10000 psi second set
	1: 6.68,
	2: 0,
	3: 0,
	4: 0,
	5: 0,
	6: 0,
},
};


